import React, { SVGProps, useId } from 'react';

interface LucideIconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export const FallbackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="h-full w-full"
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    {...props}
  >
    <path d="m2.666 11.223 16.333-7.778 16.334 7.778-16.334 7.778-16.333-7.778Z" fill="#475161" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.997 1.338a2.333 2.333 0 0 1 2.007 0l16.333 7.778a2.333 2.333 0 0 1 0 4.213l-16.333 7.778a2.333 2.333 0 0 1-2.007 0L1.665 13.329a2.333 2.333 0 0 1 0-4.213l16.334-7.778Zm-9.902 9.884L19 16.416l10.906-5.194L19 6.03 8.095 11.222ZM.561 25.776a2.333 2.333 0 0 1 3.11-1.104l15.33 7.3 15.33-7.3a2.333 2.333 0 0 1 2.007 4.214l-16.334 7.778a2.333 2.333 0 0 1-2.006 0L1.665 28.886a2.333 2.333 0 0 1-1.104-3.11Z"
      fill="#475161"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.561 17.997a2.333 2.333 0 0 1 3.11-1.104l15.33 7.3 15.33-7.3a2.333 2.333 0 0 1 2.007 4.214l-16.334 7.777a2.333 2.333 0 0 1-2.006 0L1.665 21.107a2.333 2.333 0 0 1-1.104-3.11Z"
      fill="#475161"
    />
  </svg>
);
export const TickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path fill="#B0F7BA" d="m10 16.4-4-4L7.4 11l2.6 2.6L16.6 7 18 8.4l-8 8Z" />
    </g>
  </svg>
);

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  const maskId = useId();
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M14.7 15.75L9.975 11.025C9.6 11.325 9.16875 11.5625 8.68125 11.7375C8.19375 11.9125 7.675 12 7.125 12C5.7625 12 4.60938 11.5281 3.66563 10.5844C2.72188 9.64062 2.25 8.4875 2.25 7.125C2.25 5.7625 2.72188 4.60938 3.66563 3.66563C4.60938 2.72188 5.7625 2.25 7.125 2.25C8.4875 2.25 9.64062 2.72188 10.5844 3.66563C11.5281 4.60938 12 5.7625 12 7.125C12 7.675 11.9125 8.19375 11.7375 8.68125C11.5625 9.16875 11.325 9.6 11.025 9.975L15.75 14.7L14.7 15.75ZM7.125 10.5C8.0625 10.5 8.85938 10.1719 9.51562 9.51562C10.1719 8.85938 10.5 8.0625 10.5 7.125C10.5 6.1875 10.1719 5.39062 9.51562 4.73438C8.85938 4.07812 8.0625 3.75 7.125 3.75C6.1875 3.75 5.39062 4.07812 4.73438 4.73438C4.07812 5.39062 3.75 6.1875 3.75 7.125C3.75 8.0625 4.07812 8.85938 4.73438 9.51562C5.39062 10.1719 6.1875 10.5 7.125 10.5Z"
          fill="currentColor"
          fillOpacity="0.98"
        />
      </g>
    </svg>
  );
}
export function CrossIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" fill="none" {...props}>
      <path
        fill="currentColor"
        d="m4.267 13.167-.934-.934L7.067 8.5 3.333 4.767l.934-.934L8 7.567l3.733-3.734.934.934L8.933 8.5l3.734 3.733-.934.934L8 9.433l-3.733 3.734Z"
      />
    </svg>
  );
}

/** Search bar close (X) icon – 10×10. Inactive: opacity 0.19; active (e.g. has search text): opacity 0.6. */
export function SearchCloseIcon({
  active = false,
  ...props
}: SVGProps<SVGSVGElement> & { active?: boolean }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M0.933333 9.33333L0 8.4L3.73333 4.66667L0 0.933333L0.933333 0L4.66667 3.73333L8.4 0L9.33333 0.933333L5.6 4.66667L9.33333 8.4L8.4 9.33333L4.66667 5.6L0.933333 9.33333Z"
        fill="currentColor"
        fillOpacity={active ? 0.6 : 0.19}
      />
    </svg>
  );
}
export const DividerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1}
    height={45}
    viewBox="0 0 1 45"
    fill="none"
    {...props}
  >
    <path stroke="#fff" d="M.5 0v45" strokeOpacity={props.strokeOpacity || 0.08} />
  </svg>
);
export const NextArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.98}
      d="M12.509 9.5H.334v-2h12.175l-5.6-5.6L8.334.5l8 8-8 8-1.425-1.4 5.6-5.6Z"
    />
  </svg>
);
export default NextArrowIcon;

export function ArrowHead(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="m10.65 14.667 1.183-1.184L6.35 8l5.483-5.483-1.183-1.184L3.983 8l6.667 6.667Z"
      />
    </svg>
  );
}

export function AnimatedDownArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      className="translate-y-0 opacity-100 transition-all duration-300"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1414_5733"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1414_5733)">
        <path
          d="M11 4L11 16.175L5.4 10.575L4 12L12 20L20 12L18.6 10.575L13 16.175L13 4H11Z"
          fill="#D2B7F9"
        />
      </g>
    </svg>
  );
}

export function AnimatedUpArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      className="translate-y-0 opacity-100 transition-all duration-300"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1414_5740"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1414_5740)">
        <path
          d="M13 20L13 7.825L18.6 13.425L20 12L12 4L4 12L5.4 13.425L11 7.825L11 20L13 20Z"
          fill="#B0F7BA"
        />
      </g>
    </svg>
  );
}

export function CompanyLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="157"
      height="50"
      viewBox="0 0 157 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M153.77 24.3201C152.42 24.3201 151.33 23.2301 151.33 21.8801C151.33 20.5301 152.42 19.4401 153.77 19.4401C155.12 19.4401 156.21 20.5301 156.21 21.8801C156.22 23.2201 155.12 24.3201 153.77 24.3201ZM153.77 19.6801C152.58 19.6801 151.61 20.6801 151.61 21.8701C151.61 23.0601 152.58 24.0601 153.77 24.0601C154.96 24.0601 155.93 23.0601 155.93 21.8701C155.93 20.6801 154.96 19.6801 153.77 19.6801ZM154.42 23.1601L153.75 22.0601H153.3V23.1601H153V20.5201H153.86C154.31 20.5201 154.7 20.8501 154.7 21.3001C154.7 21.6901 154.44 21.9401 154.09 22.0401L154.77 23.1701H154.42V23.1601ZM153.83 20.8101H153.3V21.7701H153.83C154.15 21.7701 154.4 21.5801 154.4 21.2901C154.4 21.0001 154.16 20.8101 153.83 20.8101Z"
        fill="#F5F5F4"
      />
      <path
        d="M118.76 19.4901C118.68 19.4901 118.65 19.5201 117.91 19.5501C117.15 19.5801 115.72 19.6101 112.81 19.6101H109.29C106.39 19.6101 104.95 19.5801 104.19 19.5501C103.46 19.5201 103.43 19.4901 103.34 19.4901C103 19.4901 103 19.7201 103 20.3601V22.9501C103 23.0901 103 23.4301 103.28 23.4301C103.59 23.4301 103.65 23.3201 104.15 22.2801C104.48 21.5601 105.15 20.5101 108.98 20.4801C109.38 20.4901 109.55 20.5801 109.55 21.2101V34.3101C109.55 35.4101 109.55 36.1701 108.14 36.2501C107.55 36.3101 107.16 36.3301 107.16 36.7301C107.16 37.1501 107.52 37.1501 107.75 37.1501C108.29 37.1501 110.57 37.0401 111.04 37.0401C111.97 37.0401 113.44 37.1501 114.36 37.1501C114.59 37.1501 114.95 37.1501 114.95 36.7301C114.95 36.3101 114.56 36.2801 113.96 36.2501C112.55 36.1701 112.55 35.4001 112.55 34.2501V21.4101C112.55 20.6801 112.64 20.5201 113.46 20.4901C116.97 20.5801 117.6 21.5901 117.92 22.2801C118.43 23.3201 118.48 23.4301 118.79 23.4301C119.07 23.4301 119.07 23.0901 119.07 22.9501V20.3601C119.1 19.7101 119.1 19.4901 118.76 19.4901Z"
        fill="#F5F5F4"
      />
      <path
        d="M88.32 32.6701C88.07 32.6701 88.01 32.7801 87.5 33.7701C86.26 36.1701 84.52 36.1701 83.28 36.1701C80.91 36.1701 80.32 35.8601 80.32 33.8601V29.0201C80.32 28.1801 80.54 28.1801 81.89 28.1801C84.2 28.1801 84.99 28.2101 85.58 30.3801C85.72 30.9201 85.89 31.0601 86.11 31.0601C86.45 31.0601 86.45 30.6701 86.45 30.5001C86.45 30.2701 86.37 29.2901 86.37 29.0901C86.37 28.4701 86.57 25.5701 86.57 25.1801C86.57 24.8701 86.43 24.7801 86.26 24.7801C86.12 24.7801 85.98 24.8401 85.84 25.2001C85.33 26.6901 85.08 27.3101 81.95 27.3101C80.32 27.3101 80.32 27.0801 80.32 26.1801V22.1001C80.32 20.6901 80.43 20.5001 81.84 20.5001C85.84 20.5001 86.52 21.5701 86.85 22.3001C87.36 23.3401 87.41 23.4501 87.72 23.4501C88 23.4501 88 23.1101 88 22.9701V20.3801C88 19.7301 88 19.5101 87.66 19.5101C87.58 19.5101 87.55 19.5401 86.82 19.5701C86.06 19.6001 84.62 19.6301 81.72 19.6301H80.37C77.97 19.6301 76.76 19.6001 76.14 19.5701C75.52 19.5401 75.49 19.5101 75.43 19.5101C75.23 19.5101 74.87 19.5101 74.87 19.9101C74.87 20.3301 75.27 20.3601 75.88 20.3901C77.29 20.4801 77.29 21.2301 77.29 22.3901V34.2801C77.29 35.4301 77.29 36.2001 75.88 36.2801C75.29 36.3401 74.87 36.3601 74.87 36.7601C74.87 37.1801 75.24 37.1801 75.46 37.1801C75.66 37.1801 75.88 37.1501 76.33 37.1201C76.78 37.0901 77.48 37.0601 78.64 37.0601H78.98C79.15 37.0601 80.47 37.0901 82.08 37.1201C83.71 37.1501 85.68 37.1801 87.12 37.1801C87.94 37.1801 88.22 36.8701 88.25 36.3301C88.34 35.2901 88.65 33.4801 88.65 33.1201C88.65 32.9301 88.57 32.6701 88.32 32.6701Z"
        fill="#F5F5F4"
      />
      <path
        d="M134.29 32.6701C134.04 32.6701 133.98 32.7801 133.47 33.7701C132.23 36.1701 130.49 36.1701 129.25 36.1701C126.88 36.1701 126.29 35.8601 126.29 33.8601V29.0201C126.29 28.1801 126.51 28.1801 127.86 28.1801C130.17 28.1801 130.96 28.2101 131.55 30.3801C131.69 30.9201 131.86 31.0601 132.08 31.0601C132.42 31.0601 132.42 30.6701 132.42 30.5001C132.42 30.2701 132.34 29.2901 132.34 29.0901C132.34 28.4701 132.54 25.5701 132.54 25.1801C132.54 24.8701 132.4 24.7801 132.23 24.7801C132.09 24.7801 131.95 24.8401 131.81 25.2001C131.3 26.6901 131.05 27.3101 127.92 27.3101C126.29 27.3101 126.29 27.0801 126.29 26.1801V22.1001C126.29 20.6901 126.4 20.5001 127.81 20.5001C131.81 20.5001 132.49 21.5701 132.82 22.3001C133.33 23.3401 133.38 23.4501 133.69 23.4501C133.97 23.4501 133.97 23.1101 133.97 22.9701V20.3801C133.97 19.7301 133.97 19.5101 133.63 19.5101C133.55 19.5101 133.52 19.5401 132.79 19.5701C132.03 19.6001 130.59 19.6301 127.69 19.6301H126.34C123.94 19.6301 122.73 19.6001 122.11 19.5701C121.49 19.5401 121.46 19.5101 121.4 19.5101C121.2 19.5101 120.84 19.5101 120.84 19.9101C120.84 20.3301 121.24 20.3601 121.85 20.3901C123.26 20.4801 123.26 21.2301 123.26 22.3901V34.2801C123.26 35.4301 123.26 36.2001 121.85 36.2801C121.26 36.3401 120.84 36.3601 120.84 36.7601C120.84 37.1801 121.21 37.1801 121.43 37.1801C121.63 37.1801 121.85 37.1501 122.3 37.1201C122.75 37.0901 123.45 37.0601 124.61 37.0601H124.95C125.12 37.0601 126.44 37.0901 128.05 37.1201C129.68 37.1501 131.65 37.1801 133.09 37.1801C133.91 37.1801 134.19 36.8701 134.22 36.3301C134.31 35.2901 134.62 33.4801 134.62 33.1201C134.62 32.9301 134.54 32.6701 134.29 32.6701Z"
        fill="#F5F5F4"
      />
      <path
        d="M97.19 26.2901C94.89 25.3401 93.22 24.6201 93.22 22.5801C93.22 21.4601 94.12 19.8301 96.35 19.8601C98.74 19.8801 99.25 21.4701 99.6 22.5801C99.89 23.4701 100 23.6401 100.29 23.6401C100.69 23.6401 100.69 23.4101 100.69 22.7801C100.69 20.2501 100.69 19.9901 100.34 19.7901C99.94 19.5901 98.24 19.1301 96.58 19.1301C92.93 19.1301 90.92 21.4301 90.92 24.0701C90.92 27.1201 93.19 28.2401 95.52 29.2701C97.59 30.2201 99.54 31.3101 99.54 33.5501C99.54 35.8801 97.27 36.6701 96.07 36.6701C94.03 36.6701 92.06 34.9501 91.51 32.4401C91.45 32.1801 91.42 31.8901 91.16 31.8901C90.81 31.8901 90.8 32.2901 90.8 32.4101C90.78 33.4501 90.91 34.6801 90.95 35.0501C91.03 35.7601 91.14 36.3401 91.46 36.5801C91.98 36.9501 93.4 37.5001 95.64 37.5001C99.46 37.5001 101.82 34.8301 101.82 31.6401C101.82 28.3901 98.8 26.9801 97.19 26.2901Z"
        fill="#F5F5F4"
      />
      <path
        d="M29.48 19.1401C23.96 19.1401 19.8 23.1001 19.8 28.2801C19.8 33.7701 24.42 37.5001 29.4 37.5001C34.24 37.5001 38.97 33.5901 38.97 28.0201C38.96 23.0801 34.81 19.1401 29.48 19.1401ZM29.62 36.7101C25.83 36.7101 23.12 32.3101 23.12 27.6801C23.12 23.6201 25.66 19.9301 29.14 19.9301C33.61 19.9301 35.62 24.7301 35.62 28.1301C35.62 32.2801 33.56 36.7101 29.62 36.7101Z"
        fill="#F5F5F4"
      />
      <path
        d="M18 12.6401C17.96 12.6401 17.92 12.6801 16.82 12.7201C15.76 12.7601 13.63 12.8001 9.4 12.8001H8.51C4.48 12.8001 3.01 12.7601 1.95 12.7201C0.930001 12.6801 0.890001 12.6401 0.810001 12.6401C0.530001 12.6401 0 12.6401 0 13.2101C0 13.7801 0.610001 13.8201 1.46 13.9001C3.5 14.0201 3.5 15.1201 3.5 16.7901V33.6501C3.5 35.0001 3.5 35.9401 1.76 36.0401C1.03 36.1101 0.550001 36.1401 0.550001 36.6301C0.550001 37.1501 1 37.1501 1.28 37.1501C1.94 37.1501 4.81 37.0101 5.4 37.0101C6.55 37.0101 8.41 37.1501 9.55 37.1501C9.83 37.1501 10.28 37.1501 10.28 36.6301C10.28 36.1101 9.8 36.0701 9.07 36.0401C7.34 35.9401 7.34 35.0001 7.34 33.5801V27.3301C7.34 26.1801 7.34 25.7201 8 25.5401C8.43 25.4201 10.31 25.4201 11.51 25.4201C12.53 25.4201 15.13 25.4201 15.7 27.6201C15.78 27.8201 16.05 28.8801 16.15 29.1701C16.22 29.3701 16.38 29.8401 16.8 29.8201C17.29 29.8001 17.29 29.3301 17.29 29.0501L17.13 27.1401C17.05 26.2001 17.05 25.5101 17.05 25.1501C17.05 24.5401 17.17 21.7701 17.17 21.2001C17.17 20.7901 17.05 20.5301 16.68 20.5101C16.32 20.4901 16.11 20.8401 16.03 21.1601C15.51 23.2701 14.93 24.1701 11.63 24.1701C11.02 24.1701 8.6 24.1701 7.99 24.0901C7.46 24.0101 7.34 23.9701 7.34 21.7701V16.0801C7.34 14.1701 8.03 14.0901 9.42 14.0901C15.75 14.0901 16.28 14.9601 17.5 17.6701C17.65 18.0101 17.81 18.4801 18.26 18.4801C18.71 18.4801 18.71 17.8301 18.71 17.7101V13.4001C18.69 12.8401 18.65 12.6401 18 12.6401Z"
        fill="#F5F5F4"
      />
      <path
        d="M55.41 36.3001C54.62 36.1801 54.23 35.4801 53.67 34.5001L50.94 29.6601C50.29 28.4801 49.95 28.3101 49.59 28.0801C50.55 27.8801 53.45 27.2101 53.45 23.9101C53.45 22.9201 53.03 19.4901 48.04 19.4901C47.19 19.4901 43.45 19.6001 42.69 19.6001C42.35 19.6001 40.97 19.4901 40.69 19.4901C39.76 19.4901 39.65 19.4901 39.65 19.8901C39.65 20.2801 40.05 20.3101 40.66 20.3401C42.04 20.4201 42.04 21.1901 42.04 22.3401V34.2801C42.04 35.4601 42.04 36.2001 40.66 36.3101C40.07 36.3401 39.65 36.3701 39.65 36.7601C39.65 37.1801 40.02 37.1501 40.24 37.1501C40.75 37.1501 43.03 37.0401 43.51 37.0401C43.62 37.0401 46.36 37.1501 46.89 37.1501C47.11 37.1501 47.48 37.1801 47.48 36.7801C47.48 36.3601 47.08 36.3301 46.47 36.3001C45.06 36.2201 45.06 35.4501 45.06 34.2701V29.2001C45.06 28.7201 45.12 28.5501 45.6 28.5501C46.87 28.5501 47.01 28.6601 47.63 29.8701L51.04 36.2901C51.35 36.8801 51.46 37.1401 51.97 37.1401C52.22 37.1401 55.32 37.1401 55.68 37.1401C55.88 37.1401 56.16 37.0901 56.16 36.8001C56.13 36.5001 56 36.3901 55.41 36.3001ZM46.45 27.8301C45.04 27.8301 45.04 27.7701 45.04 26.7901V22.0601C45.04 20.9601 45.07 20.2901 46.36 20.2901C49.85 20.2901 50.25 23.3001 50.25 24.3201C50.25 27.8301 47.47 27.8301 46.45 27.8301Z"
        fill="#F5F5F4"
      />
      <path
        d="M73.08 36.3001C72.29 36.1801 71.9 35.4801 71.34 34.5001L68.61 29.6601C67.96 28.4801 67.62 28.3101 67.26 28.0801C68.22 27.8801 71.12 27.2101 71.12 23.9101C71.12 22.9201 70.7 19.4901 65.71 19.4901C64.86 19.4901 61.12 19.6001 60.36 19.6001C60.02 19.6001 58.64 19.4901 58.36 19.4901C57.43 19.4901 57.32 19.4901 57.32 19.8901C57.32 20.2801 57.72 20.3101 58.33 20.3401C59.71 20.4201 59.71 21.1901 59.71 22.3401V34.2801C59.71 35.4601 59.71 36.2001 58.33 36.3101C57.74 36.3401 57.32 36.3701 57.32 36.7601C57.32 37.1801 57.69 37.1501 57.91 37.1501C58.42 37.1501 60.7 37.0401 61.18 37.0401C61.29 37.0401 64.03 37.1501 64.56 37.1501C64.78 37.1501 65.15 37.1801 65.15 36.7801C65.15 36.3601 64.75 36.3301 64.14 36.3001C62.73 36.2201 62.73 35.4501 62.73 34.2701V29.2001C62.73 28.7201 62.79 28.5501 63.27 28.5501C64.54 28.5501 64.68 28.6601 65.3 29.8701L68.71 36.2901C69.02 36.8801 69.13 37.1401 69.64 37.1401C69.89 37.1401 72.99 37.1401 73.35 37.1401C73.55 37.1401 73.83 37.0901 73.83 36.8001C73.8 36.5001 73.67 36.3901 73.08 36.3001ZM64.12 27.8301C62.71 27.8301 62.71 27.7701 62.71 26.7901V22.0601C62.71 20.9601 62.74 20.2901 64.03 20.2901C67.52 20.2901 67.92 23.3001 67.92 24.3201C67.92 27.8301 65.14 27.8301 64.12 27.8301Z"
        fill="#F5F5F4"
      />
      <path
        d="M151.98 36.3001C151.19 36.1801 150.8 35.4801 150.24 34.5001L147.51 29.6601C146.86 28.4801 146.52 28.3101 146.16 28.0801C147.12 27.8801 150.02 27.2101 150.02 23.9101C150.02 22.9201 149.6 19.4901 144.61 19.4901C143.76 19.4901 140.02 19.6001 139.26 19.6001C138.92 19.6001 137.54 19.4901 137.26 19.4901C136.33 19.4901 136.22 19.4901 136.22 19.8901C136.22 20.2801 136.62 20.3101 137.23 20.3401C138.61 20.4201 138.61 21.1901 138.61 22.3401V34.2801C138.61 35.4601 138.61 36.2001 137.23 36.3101C136.64 36.3401 136.22 36.3701 136.22 36.7601C136.22 37.1801 136.59 37.1501 136.81 37.1501C137.32 37.1501 139.6 37.0401 140.08 37.0401C140.19 37.0401 142.93 37.1501 143.46 37.1501C143.68 37.1501 144.05 37.1801 144.05 36.7801C144.05 36.3601 143.65 36.3301 143.04 36.3001C141.63 36.2201 141.63 35.4501 141.63 34.2701V29.2001C141.63 28.7201 141.69 28.5501 142.17 28.5501C143.44 28.5501 143.58 28.6601 144.2 29.8701L147.61 36.2901C147.92 36.8801 148.03 37.1401 148.54 37.1401C148.79 37.1401 151.89 37.1401 152.25 37.1401C152.45 37.1401 152.73 37.0901 152.73 36.8001C152.71 36.5001 152.57 36.3901 151.98 36.3001ZM143.03 27.8301C141.62 27.8301 141.62 27.7701 141.62 26.7901V22.0601C141.62 20.9601 141.65 20.2901 142.94 20.2901C146.43 20.2901 146.83 23.3001 146.83 24.3201C146.83 27.8301 144.04 27.8301 143.03 27.8301Z"
        fill="#F5F5F4"
      />
    </svg>
  );
}

export const PaginationArrow = (props: SVGProps<SVGSVGElement>) => {
  const { className = 'size-4' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M16 0H0v16h16z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          d="m10.65 14.667 1.183-1.184L6.35 8l5.483-5.483-1.183-1.183L3.983 8l6.667 6.667Z"
        />
      </g>
    </svg>
  );
};

export const PaginationArrowLogin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={7} fill="none" {...props}>
    <path fill="#fff" fillOpacity={0.98} d="m5 6.833 5-5L8.833.667 5 4.5 1.167.667 0 1.833l5 5Z" />
  </svg>
);

export function Arrow_Outward(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.913162 7.79248L0.304016 7.18333L6.04431 1.4375H0.825662V0.5625H7.534V7.27083H6.659V2.05219L0.913162 7.79248Z"
        fill="white"
        fillOpacity="0.45"
      />
    </svg>
  );
}

export function PlayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path fill="currentColor" d="M8 5v14l11-7z" />
    </svg>
  );
}

export function PauseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path fill="currentColor" d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
    </svg>
  );
}

export function PodcastPlayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_18516_968"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <rect width="41" height="41" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18516_968)">
        <path
          d="M16.6562 27.3995L27.399 20.5003L16.6562 13.6012V27.3995ZM20.5029 36.7295C18.2582 36.7295 16.1482 36.3036 14.1731 35.4517C12.198 34.5998 10.48 33.4437 9.01906 31.9833C7.55815 30.523 6.40147 28.8057 5.54901 26.8314C4.69684 24.8572 4.27075 22.7478 4.27075 20.5033C4.27075 18.2586 4.6967 16.1487 5.54859 14.1735C6.40047 12.1984 7.55659 10.4804 9.01693 9.01949C10.4773 7.55858 12.1946 6.4019 14.1688 5.54944C16.1431 4.69727 18.2525 4.27118 20.4969 4.27118C22.7417 4.27118 24.8516 4.69712 26.8267 5.54901C28.8018 6.4009 30.5199 7.55702 31.9808 9.01736C33.4417 10.4777 34.5984 12.195 35.4508 14.1693C36.303 16.1435 36.7291 18.2529 36.7291 20.4974C36.7291 22.7421 36.3031 24.852 35.4513 26.8272C34.5994 28.8023 33.4432 30.5203 31.9829 31.9812C30.5226 33.4421 28.8053 34.5988 26.831 35.4513C24.8567 36.3034 22.7474 36.7295 20.5029 36.7295ZM20.4999 34.167C24.3152 34.167 27.5468 32.8431 30.1947 30.1951C32.8426 27.5472 34.1666 24.3156 34.1666 20.5003C34.1666 16.6851 32.8426 13.4535 30.1947 10.8056C27.5468 8.15764 24.3152 6.83368 20.4999 6.83368C16.6846 6.83368 13.453 8.15764 10.8051 10.8056C8.15721 13.4535 6.83325 16.6851 6.83325 20.5003C6.83325 24.3156 8.15721 27.5472 10.8051 30.1951C13.453 32.8431 16.6846 34.167 20.4999 34.167Z"
          fill="#AC75FF"
        />
      </g>
    </svg>
  );
}

export function PodcastAudioPauseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_20141_1684"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="41"
      >
        <rect width="41" height="41" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_20141_1684)">
        <path
          d="M20.5029 36.7295C18.2582 36.7295 16.1482 36.3036 14.1731 35.4517C12.198 34.5998 10.48 33.4437 9.01906 31.9833C7.55815 30.523 6.40147 28.8057 5.54901 26.8314C4.69684 24.8572 4.27075 22.7478 4.27075 20.5033C4.27075 18.2586 4.6967 16.1487 5.54859 14.1735C6.40047 12.1984 7.55659 10.4804 9.01693 9.01949C10.4773 7.55858 12.1946 6.4019 14.1688 5.54944C16.1431 4.69727 18.2525 4.27118 20.4969 4.27118C22.7417 4.27118 24.8516 4.69712 26.8267 5.54901C28.8018 6.4009 30.5199 7.55702 31.9808 9.01736C33.4417 10.4777 34.5984 12.195 35.4508 14.1693C36.303 16.1435 36.7291 18.2529 36.7291 20.4974C36.7291 22.7421 36.3031 24.852 35.4513 26.8272C34.5994 28.8023 33.4432 30.5203 31.9829 31.9812C30.5226 33.4421 28.8053 34.5988 26.831 35.4513C24.8567 36.3034 22.7474 36.7295 20.5029 36.7295ZM20.4999 34.167C24.3152 34.167 27.5468 32.8431 30.1947 30.1951C32.8426 27.5472 34.1666 24.3156 34.1666 20.5003C34.1666 16.6851 32.8426 13.4535 30.1947 10.8056C27.5468 8.15764 24.3152 6.83368 20.4999 6.83368C16.6846 6.83368 13.453 8.15764 10.8051 10.8056C8.15721 13.4535 6.83325 16.6851 6.83325 20.5003C6.83325 24.3156 8.15721 27.5472 10.8051 30.1951C13.453 32.8431 16.6846 34.167 20.4999 34.167Z"
          fill="#AC75FF"
        />
        <path
          d="M15.5 28C16.3284 28 17 27.3284 17 26.5V14.5C17 13.6716 16.3284 13 15.5 13C14.6716 13 14 13.6716 14 14.5V26.5C14 27.3284 14.6716 28 15.5 28Z"
          fill="#AC75FF"
        />
        <path
          d="M25.5 28C26.3284 28 27 27.3284 27 26.5V14.5C27 13.6716 26.3284 13 25.5 13C24.6716 13 24 13.6716 24 14.5V26.5C24 27.3284 24.6716 28 25.5 28Z"
          fill="#AC75FF"
        />
      </g>
    </svg>
  );
}

export function AudioPlayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_18658_1128"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={18}
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18658_1128)">
        <path
          d="M7.3125 12.029L12.0289 9.00012L7.3125 5.97125V12.029ZM9.00131 16.1251C8.01581 16.1251 7.0895 15.9381 6.22237 15.5641C5.35525 15.1901 4.601 14.6826 3.95962 14.0414C3.31825 13.4003 2.81044 12.6464 2.43619 11.7796C2.06206 10.9129 1.875 9.98681 1.875 9.00143C1.875 8.01593 2.062 7.08962 2.436 6.2225C2.81 5.35537 3.31756 4.60112 3.95869 3.95975C4.59981 3.31837 5.35375 2.81056 6.2205 2.43631C7.08725 2.06218 8.01331 1.87512 8.99869 1.87512C9.98419 1.87512 10.9105 2.06212 11.7776 2.43612C12.6448 2.81012 13.399 3.31768 14.0404 3.95881C14.6818 4.59993 15.1896 5.35387 15.5638 6.22062C15.9379 7.08737 16.125 8.01343 16.125 8.99881C16.125 9.98431 15.938 10.9106 15.564 11.7777C15.19 12.6449 14.6824 13.3991 14.0413 14.0405C13.4002 14.6819 12.6463 15.1897 11.7795 15.5639C10.9128 15.9381 9.98669 16.1251 9.00131 16.1251ZM9 15.0001C10.675 15.0001 12.0938 14.4189 13.2563 13.2564C14.4187 12.0939 15 10.6751 15 9.00012C15 7.32512 14.4187 5.90637 13.2563 4.74387C12.0938 3.58137 10.675 3.00012 9 3.00012C7.325 3.00012 5.90625 3.58137 4.74375 4.74387C3.58125 5.90637 3 7.32512 3 9.00012C3 10.6751 3.58125 12.0939 4.74375 13.2564C5.90625 14.4189 7.325 15.0001 9 15.0001Z"
          fill="#F5F5F4"
        />
      </g>
    </svg>
  );
}

export function AudioPauseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_20141_1684"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_20141_1684)">
        <path
          d="M9.00131 16.1251C8.01581 16.1251 7.0895 15.9381 6.22237 15.5641C5.35525 15.1901 4.601 14.6826 3.95962 14.0414C3.31825 13.4003 2.81044 12.6464 2.43619 11.7796C2.06206 10.9129 1.875 9.98681 1.875 9.00143C1.875 8.01593 2.062 7.08962 2.436 6.2225C2.81 5.35537 3.31756 4.60112 3.95869 3.95975C4.59981 3.31837 5.35375 2.81056 6.2205 2.43631C7.08725 2.06218 8.01331 1.87512 8.99869 1.87512C9.98419 1.87512 10.9105 2.06212 11.7776 2.43612C12.6448 2.81012 13.399 3.31768 14.0404 3.95881C14.6818 4.59993 15.1896 5.35387 15.5638 6.22062C15.9379 7.08737 16.125 8.01343 16.125 8.99881C16.125 9.98431 15.938 10.9106 15.564 11.7777C15.19 12.6449 14.6824 13.3991 14.0413 14.0405C13.4002 14.6819 12.6463 15.1897 11.7795 15.5639C10.9128 15.9381 9.98669 16.1251 9.00131 16.1251ZM9 15.0001C10.675 15.0001 12.0938 14.4189 13.2563 13.2564C14.4188 12.0939 15 10.6751 15 9.00012C15 7.32512 14.4188 5.90637 13.2563 4.74387C12.0938 3.58137 10.675 3.00012 9 3.00012C7.325 3.00012 5.90625 3.58137 4.74375 4.74387C3.58125 5.90637 3 7.32512 3 9.00012C3 10.6751 3.58125 12.0939 4.74375 13.2564C5.90625 14.4189 7.325 15.0001 9 15.0001Z"
          fill="#F5F5F4"
        />
        <path
          d="M7.5 12C7.77618 12 8 11.7203 8 11.375V6.62501C8 6.27978 7.77622 6 7.5 6C7.22382 6 7 6.27973 7 6.62501V11.375C7 11.7203 7.22378 12 7.5 12Z"
          fill="#EBEBEA"
        />
        <path
          d="M10.5 12C10.7762 12 11 11.7203 11 11.375V6.62501C11 6.27978 10.7762 6 10.5 6C10.2238 6 10 6.27978 10 6.62501V11.375C10 11.7203 10.2238 12 10.5 12Z"
          fill="#EBEBEA"
        />
      </g>
    </svg>
  );
}

export function AudioMuteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_20141_1694"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_20141_1694)">
        <path
          d="M2.25 11.2501V6.75012H5.25L9 3.00012V15.0001L5.25 11.2501H2.25ZM7.5 6.63762L5.8875 8.25012H3.75V9.75012H5.8875L7.5 11.3626V6.63762Z"
          fill="#F5F5F4"
        />
        <path
          d="M15.2994 7.20057C15.032 6.93314 14.5988 6.93314 14.3314 7.20057L13.5 8.03195L12.6686 7.20057C12.4012 6.93314 11.968 6.93314 11.7006 7.20057C11.4332 7.468 11.4331 7.90144 11.7006 8.16865L12.532 9L11.7006 9.83136C11.4331 10.0988 11.4331 10.532 11.7006 10.7994C11.8343 10.9331 12.0094 11 12.1846 11C12.3597 11 12.5349 10.9331 12.6686 10.7994L13.5 9.96805L14.3314 10.7994C14.4651 10.9331 14.6403 11 14.8154 11C14.9906 11 15.1657 10.9331 15.2994 10.7994C15.5669 10.532 15.5669 10.0988 15.2994 9.83136L14.4681 9L15.2994 8.16865C15.5668 7.90144 15.5668 7.468 15.2994 7.20057Z"
          fill="#EBEBEA"
        />
      </g>
    </svg>
  );
}

export function AudioUnmuteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_18658_1135"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={19}
        height="18"
      >
        <rect x="0.0878906" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18658_1135)">
        <path
          d="M12.0879 9.75012V8.25012H15.0879V9.75012H12.0879ZM12.9879 15.0001L10.5879 13.2001L11.4879 12.0001L13.8879 13.8001L12.9879 15.0001ZM11.4879 6.00012L10.5879 4.80012L12.9879 3.00012L13.8879 4.20012L11.4879 6.00012ZM2.33789 11.2501V6.75012H5.33789L9.08789 3.00012V15.0001L5.33789 11.2501H2.33789ZM7.58789 6.63762L5.97539 8.25012H3.83789V9.75012H5.97539L7.58789 11.3626V6.63762Z"
          fill="#F5F5F4"
        />
      </g>
    </svg>
  );
}

export function AudioRewindIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_18658_1139"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={19}
        height={18}
      >
        <rect width={18} height={18} transform="matrix(-1 0 0 1 18.1758 0)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18658_1139)">
        <path
          d="M9.17578 16.5001C10.1133 16.5001 10.9914 16.322 11.8102 15.9657C12.6289 15.6095 13.3414 15.1282 13.9477 14.522C14.5539 13.9157 15.0352 13.2032 15.3914 12.3845C15.7477 11.5657 15.9258 10.6876 15.9258 9.75012C15.9258 8.81262 15.7477 7.9345 15.3914 7.11575C15.0352 6.297 14.5539 5.5845 13.9477 4.97825C13.3414 4.372 12.6289 3.89075 11.8102 3.5345C10.9914 3.17825 10.1133 3.00012 9.17578 3.00012H9.06328L10.2258 1.83762L9.17578 0.750122L6.17578 3.75012L9.17578 6.75012L10.2258 5.66262L9.06328 4.50012H9.17578C10.6383 4.50012 11.8789 5.0095 12.8977 6.02825C13.9164 7.047 14.4258 8.28762 14.4258 9.75012C14.4258 11.2126 13.9164 12.4532 12.8977 13.472C11.8789 14.4907 10.6383 15.0001 9.17578 15.0001C7.71328 15.0001 6.47266 14.4907 5.45391 13.472C4.43516 12.4532 3.92578 11.2126 3.92578 9.75012H2.42578C2.42578 10.6876 2.60391 11.5657 2.96016 12.3845C3.31641 13.2032 3.79766 13.9157 4.40391 14.522C5.01016 15.1282 5.72266 15.6095 6.54141 15.9657C7.36016 16.322 8.23828 16.5001 9.17578 16.5001Z"
          fill="#F5F5F4"
        />
        <path
          d="M6.92578 8.62488V11.9999H8.05078V7.49988H5.80078V8.62488H6.92578Z"
          fill="#F5F5F4"
        />
        <path
          d="M9.01641 11.7843C9.16016 11.928 9.33828 11.9999 9.55078 11.9999H11.0508C11.2633 11.9999 11.4414 11.928 11.5852 11.7843C11.7289 11.6405 11.8008 11.4624 11.8008 11.2499V8.24988C11.8008 8.03738 11.7289 7.85925 11.5852 7.7155C11.4414 7.57175 11.2633 7.49988 11.0508 7.49988H9.55078C9.33828 7.49988 9.16016 7.57175 9.01641 7.7155C8.87266 7.85925 8.80078 8.03738 8.80078 8.24988V11.2499C8.80078 11.4624 8.87266 11.6405 9.01641 11.7843Z"
          fill="#F5F5F4"
        />
        <path d="M10.6758 10.8751H9.92578V8.62512H10.6758V10.8751Z" fill="#393838" />
      </g>
    </svg>
  );
}

export function AudioForwardIcon() {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.625 12.0001V10.8751H5.5V10.1251H4.375V9.37512H5.5V8.62512H3.625V7.50012H5.875C6.0875 7.50012 6.26562 7.572 6.40937 7.71575C6.55312 7.8595 6.625 8.03762 6.625 8.25012V11.2501C6.625 11.4626 6.55312 11.6407 6.40937 11.7845C6.26562 11.9282 6.0875 12.0001 5.875 12.0001H3.625ZM8.125 12.0001C7.9125 12.0001 7.73437 11.9282 7.59062 11.7845C7.44687 11.6407 7.375 11.4626 7.375 11.2501V8.25012C7.375 8.03762 7.44687 7.8595 7.59062 7.71575C7.73437 7.572 7.9125 7.50012 8.125 7.50012H9.625C9.8375 7.50012 10.0156 7.572 10.1594 7.71575C10.3031 7.8595 10.375 8.03762 10.375 8.25012V11.2501C10.375 11.4626 10.3031 11.6407 10.1594 11.7845C10.0156 11.9282 9.8375 12.0001 9.625 12.0001H8.125ZM8.5 10.8751H9.25V8.62512H8.5V10.8751ZM7 16.5001C6.0625 16.5001 5.18437 16.322 4.36562 15.9657C3.54687 15.6095 2.83437 15.1282 2.22812 14.522C1.62187 13.9157 1.14062 13.2032 0.784375 12.3845C0.428125 11.5657 0.25 10.6876 0.25 9.75012C0.25 8.81262 0.428125 7.9345 0.784375 7.11575C1.14062 6.297 1.62187 5.5845 2.22812 4.97825C2.83437 4.372 3.54687 3.89075 4.36562 3.5345C5.18437 3.17825 6.0625 3.00012 7 3.00012H7.1125L5.95 1.83762L7 0.750122L10 3.75012L7 6.75012L5.95 5.66262L7.1125 4.50012H7C5.5375 4.50012 4.29687 5.0095 3.27812 6.02825C2.25937 7.047 1.75 8.28762 1.75 9.75012C1.75 11.2126 2.25937 12.4532 3.27812 13.472C4.29687 14.4907 5.5375 15.0001 7 15.0001C8.4625 15.0001 9.70312 14.4907 10.7219 13.472C11.7406 12.4532 12.25 11.2126 12.25 9.75012H13.75C13.75 10.6876 13.5719 11.5657 13.2156 12.3845C12.8594 13.2032 12.3781 13.9157 11.7719 14.522C11.1656 15.1282 10.4531 15.6095 9.63437 15.9657C8.81562 16.322 7.9375 16.5001 7 16.5001Z"
        fill="#F5F5F4"
      />
    </svg>
  );
}

export function XIcon({ className = '', size = 24, strokeWidth = 2 }: LucideIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}

export function ArrowLeft({ className = '', size = 24, strokeWidth = 2 }: LucideIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  );
}
export const FilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        fillOpacity={0.98}
        d="M11.385 19.5a.856.856 0 0 1-.631-.254.856.856 0 0 1-.254-.63v-5.789L4.902 5.715c-.192-.256-.22-.523-.084-.8.137-.277.367-.415.692-.415h12.98c.325 0 .555.138.692.415.136.277.108.544-.084.8L13.5 12.828v5.788a.856.856 0 0 1-.254.631.856.856 0 0 1-.63.254h-1.231ZM12 12.3 16.95 6h-9.9L12 12.3Z"
      />
    </g>
  </svg>
);

export function ArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.78854 9.42292L6.91021 8.51917L10.0929 5.33646H0V4.08646H10.0929L6.91021 0.90375L7.78854 0L12.5 4.71146L7.78854 9.42292Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CheckIcon({ className = '', size = 24, strokeWidth = 2 }: LucideIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export function ChevronRightIcon({
  className = '',
  size = 24,
  strokeWidth = 2,
  style,
}: LucideIconProps & { style?: React.CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}
export function ArrowRightIcon({
  className = '',
  size,
  width = size || 12,
  height = size || 10,
  strokeWidth = 1,
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      className={className}
      strokeWidth={strokeWidth}
      width={width}
      height={height}
      viewBox="0 0 12 10"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 9.06667L5.78333 7.6L7.8 5.58333H0V3.48333H7.8L5.78333 1.46667L7.25 0L11.8 4.53333L7.25 9.06667Z"
        fill="currentColor"
        fillOpacity="1"
      />
    </svg>
  );
}

export function ChevronLeftIcon({
  className = '',
  size = 24,
  strokeWidth = 2,
  style,
}: LucideIconProps & { style?: React.CSSProperties }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d="m15 18-6-6 6-6" />
    </svg>
  );
}

export function CircleIcon({ className = '', size = 24, strokeWidth = 2 }: LucideIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
}

export const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    {...props}
  >
    <g mask="url(#mask0_16699_865)">
      <path
        d="M6.63746 13.1187L8.99996 11.6937L11.3625 13.1375L10.7437 10.4375L12.825 8.63749L10.0875 8.39374L8.99996 5.84374L7.91246 8.37499L5.17496 8.61874L7.25621 10.4375L6.63746 13.1187ZM4.93121 15.4711L6.00577 10.8442L2.41589 7.73318L7.15233 7.32218L8.99996 2.95924L10.8476 7.32218L15.584 7.73318L11.9941 10.8442L13.0687 15.4711L8.99996 13.0164L4.93121 15.4711Z"
        fill="white"
      />
    </g>
  </svg>
);

export const ApplePodcastsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#9933CC" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Apple Podcasts</title>
    <path d="M5.34 0A5.328 5.328 0 000 5.34v13.32A5.328 5.328 0 005.34 24h13.32A5.328 5.328 0 0024 18.66V5.34A5.328 5.328 0 0018.66 0zm6.525 2.568c2.336 0 4.448.902 6.056 2.587 1.224 1.272 1.912 2.619 2.264 4.392.12.59.12 2.2.007 2.864a8.506 8.506 0 01-3.24 5.296c-.608.46-2.096 1.261-2.336 1.261-.088 0-.096-.091-.056-.46.072-.592.144-.715.48-.856.536-.224 1.448-.874 2.008-1.435a7.644 7.644 0 002.008-3.536c.208-.824.184-2.656-.048-3.504-.728-2.696-2.928-4.792-5.624-5.352-.784-.16-2.208-.16-3 0-2.728.56-4.984 2.76-5.672 5.528-.184.752-.184 2.584 0 3.336.456 1.832 1.64 3.512 3.192 4.512.304.2.672.408.824.472.336.144.408.264.472.856.04.36.03.464-.056.464-.056 0-.464-.176-.896-.384l-.04-.03c-2.472-1.216-4.056-3.274-4.632-6.012-.144-.706-.168-2.392-.03-3.04.36-1.74 1.048-3.1 2.192-4.304 1.648-1.737 3.768-2.656 6.128-2.656zm.134 2.81c.409.004.803.04 1.106.106 2.784.62 4.76 3.408 4.376 6.174-.152 1.114-.536 2.03-1.216 2.88-.336.43-1.152 1.15-1.296 1.15-.023 0-.048-.272-.048-.603v-.605l.416-.496c1.568-1.878 1.456-4.502-.256-6.224-.664-.67-1.432-1.064-2.424-1.246-.64-.118-.776-.118-1.448-.008-1.02.167-1.81.562-2.512 1.256-1.72 1.704-1.832 4.342-.264 6.222l.413.496v.608c0 .336-.027.608-.06.608-.03 0-.264-.16-.512-.36l-.034-.011c-.832-.664-1.568-1.842-1.872-2.997-.184-.698-.184-2.024.008-2.72.504-1.878 1.888-3.335 3.808-4.019.41-.145 1.133-.22 1.814-.211zm-.13 2.99c.31 0 .62.06.844.178.488.253.888.745 1.04 1.259.464 1.578-1.208 2.96-2.72 2.254h-.015c-.712-.331-1.096-.956-1.104-1.77 0-.733.408-1.371 1.112-1.745.224-.117.534-.176.844-.176zm-.011 4.728c.988-.004 1.706.349 1.97.97.198.464.124 1.932-.218 4.302-.232 1.656-.36 2.074-.68 2.356-.44.39-1.064.498-1.656.288h-.003c-.716-.257-.87-.605-1.164-2.644-.341-2.37-.416-3.838-.218-4.302.262-.616.974-.966 1.97-.97z" />
  </svg>
);

export const SpotifyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#1DB954" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Spotify</title>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
  </svg>
);

export const GooglePodcastsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <title>Google Podcasts</title>
    <g fill="none">
      <path
        d="M64 238.545v34.91c0 17.673-14.327 32-32 32s-32-14.327-32-32v-34.91c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        fill="#0066d9"
      />
      <path
        d="M448.013 239.455a32.6 32.6 0 0 1-.013-.91c0-17.673 14.327-32 32-32s32 14.327 32 32c0 .304-.004.608-.013.91H512v34.909h-.013c-.48 17.252-14.618 31.09-31.987 31.09s-31.506-13.838-31.987-31.09H448v-34.91h.013z"
        fill="#4285f4"
      />
      <path
        d="M174.545 343.273v34.909c0 17.673-14.326 32-32 32s-32-14.327-32-32v-34.91c0-17.672 14.327-32 32-32s32 14.328 32 32zM174.545 133.818V248h-.008c-.386 17.337-14.562 31.273-31.992 31.273S110.94 265.337 110.554 248h-.009V133.818c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        fill="#ea4335"
      />
      <path
        d="M337.455 168.727c0 17.673 14.326 32 32 32s32-14.327 32-32v-34.909c0-17.673-14.327-32-32-32s-32 14.327-32 32z"
        fill="#34a853"
      />
      <path
        d="M224 66.91c0 17.672 14.327 32 32 32s32-14.328 32-32V32c0-17.673-14.327-32-32-32s-32 14.327-32 32zM224 445.09c0-17.672 14.327-32 32-32s32 14.328 32 32V480c0 17.673-14.327 32-32 32s-32-14.327-32-32z"
        fill="#fab908"
      />
      <path
        d="M337.455 264.727c0-17.673 14.326-32 32-32s32 14.327 32 32v113.455c0 17.673-14.327 32-32 32s-32-14.327-32-32z"
        fill="#34a853"
      />
      <path
        d="M288 162.91v186.18c0 17.674-14.327 32-32 32s-32-14.326-32-32V162.91c0-17.674 14.327-32 32-32s32 14.326 32 32z"
        fill="#fab908"
      />
    </g>
  </svg>
);

export const OvercastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#FC7E0F" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Overcast</title>
    <path d="M12 24C5.389 24.018.017 18.671 0 12.061V12C0 5.35 5.351 0 12 0s12 5.35 12 12c0 6.649-5.351 12-12 12zm0-4.751l.9-.899-.9-3.45-.9 3.45.9.899zm-1.15-.05L10.4 20.9l1.05-1.052-.6-.649zm2.3 0l-.6.601 1.05 1.051-.45-1.652zm.85 3.102L12 20.3l-2 2.001c.65.1 1.3.199 2 .199s1.35-.05 2-.199zM12 1.5C6.201 1.5 1.5 6.201 1.5 12c-.008 4.468 2.825 8.446 7.051 9.899l2.25-8.35c-.511-.372-.809-.968-.801-1.6 0-1.101.9-2.001 2-2.001s2 .9 2 2.001c0 .649-.301 1.2-.801 1.6l2.25 8.35c4.227-1.453 7.06-5.432 7.051-9.899 0-5.799-4.701-10.5-10.5-10.5zm6.85 15.7c-.255.319-.714.385-1.049.15-.313-.207-.4-.628-.194-.941.014-.021.028-.04.044-.06 0 0 1.35-1.799 1.35-4.35s-1.35-4.35-1.35-4.35c-.239-.289-.198-.719.091-.957.02-.016.039-.031.06-.044.335-.235.794-.169 1.049.15.1.101 1.65 2.15 1.65 5.2S18.949 17.1 18.85 17.2zm-3.651-1.95c-.3-.3-.249-.85.051-1.15 0 0 .75-.799.75-2.1s-.75-2.051-.75-2.1c-.3-.301-.3-.801-.051-1.15.232-.303.666-.357.969-.125.029.022.056.047.082.074C16.301 8.75 17.5 10 17.5 12s-1.199 3.25-1.25 3.301c-.301.299-.75.25-1.051-.051zm-6.398 0c-.301.301-.75.35-1.051.051C7.699 15.199 6.5 14 6.5 12s1.199-3.199 1.25-3.301c.301-.299.801-.299 1.051.051.3.3.249.85-.051 1.15 0 .049-.75.799-.75 2.1s.75 2.1.75 2.1c.3.3.351.799.051 1.15zm-2.602 2.101c-.335.234-.794.169-1.05-.15C5.051 17.1 3.5 15.05 3.5 12s1.551-5.1 1.649-5.2c.256-.319.715-.386 1.05-.15.313.206.4.628.194.941-.013.02-.028.04-.043.059C6.35 7.65 5 9.449 5 12s1.35 4.35 1.35 4.35c.25.3.15.75-.151 1.001z" />
  </svg>
);

export const PocketCastsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#F43E37" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Pocket Casts</title>
    <path d="M12,0C5.372,0,0,5.372,0,12c0,6.628,5.372,12,12,12c6.628,0,12-5.372,12-12 C24,5.372,18.628,0,12,0z M15.564,12c0-1.968-1.596-3.564-3.564-3.564c-1.968,0-3.564,1.595-3.564,3.564 c0,1.968,1.595,3.564,3.564,3.564V17.6c-3.093,0-5.6-2.507-5.6-5.6c0-3.093,2.507-5.6,5.6-5.6c3.093,0,5.6,2.507,5.6,5.6H15.564z M19,12c0-3.866-3.134-7-7-7c-3.866,0-7,3.134-7,7c0,3.866,3.134,7,7,7v2.333c-5.155,0-9.333-4.179-9.333-9.333 c0-5.155,4.179-9.333,9.333-9.333c5.155,0,9.333,4.179,9.333,9.333H19z" />
  </svg>
);

export const AmazonMusicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="2.167 .438 251.038 259.969"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Amazon Music</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="m221.503 210.324c-105.235 50.083-170.545 8.18-212.352-17.271-2.587-1.604-6.984.375-3.169 4.757 13.928 16.888 59.573 57.593 119.153 57.593 59.621 0 95.09-32.532 99.527-38.207 4.407-5.627 1.294-8.731-3.16-6.872zm29.555-16.322c-2.826-3.68-17.184-4.366-26.22-3.256-9.05 1.078-22.634 6.609-21.453 9.93.606 1.244 1.843.686 8.06.127 6.234-.622 23.698-2.826 27.337 1.931 3.656 4.79-5.57 27.608-7.255 31.288-1.628 3.68.622 4.629 3.68 2.178 3.016-2.45 8.476-8.795 12.14-17.774 3.639-9.028 5.858-21.622 3.71-24.424z"
        fill="#4BA5DC"
        fillRule="nonzero"
      />
      <path
        d="m150.744 108.13c0 13.141.332 24.1-6.31 35.77-5.361 9.489-13.853 15.324-23.341 15.324-12.952 0-20.495-9.868-20.495-24.432 0-28.75 25.76-33.968 50.146-33.968zm34.015 82.216c-2.23 1.992-5.456 2.135-7.97.806-11.196-9.298-13.189-13.615-19.356-22.487-18.502 18.882-31.596 24.527-55.601 24.527-28.37 0-50.478-17.506-50.478-52.565 0-27.373 14.85-46.018 35.96-55.126 18.313-8.066 43.884-9.489 63.43-11.718v-4.365c0-8.018.616-17.506-4.08-24.432-4.128-6.215-12.003-8.777-18.93-8.777-12.856 0-24.337 6.594-27.136 20.257-.57 3.037-2.799 6.026-5.835 6.168l-32.735-3.51c-2.751-.618-5.787-2.847-5.028-7.07 7.543-39.66 43.36-51.616 75.43-51.616 16.415 0 37.858 4.365 50.81 16.795 16.415 15.323 14.849 35.77 14.849 58.02v52.565c0 15.798 6.547 22.724 12.714 31.264 2.182 3.036 2.657 6.69-.095 8.966-6.879 5.74-19.119 16.415-25.855 22.393l-.095-.095"
        fill="#000"
      />
    </g>
  </svg>
);

export const CastroIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <linearGradient x1="0%" y1="0%" x2="0%" y2="100%" id="castro-linearGradient-1">
        <stop stopColor="#00CCBF" offset="0%" />
        <stop stopColor="#00B265" offset="100%" />
      </linearGradient>
      <linearGradient x1="0%" y1="0%" x2="0%" y2="100%" id="castro-linearGradient-2">
        <stop stopColor="#151515" offset="0%" />
        <stop stopColor="#353535" offset="100%" />
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="castro-c2icon-copy">
        <path
          d="M11.8538809,6.640625e-05 L22.1461191,6.640625e-05 C25.5594004,6.640625e-05 27.2659082,6.640625e-05 29.1031699,0.580955078 C31.1089375,1.31102539 32.6889746,2.8910625 33.4191113,4.89689648 C33.9999336,6.73402539 33.9999336,8.44059961 33.9999336,11.8538809 L33.9999336,22.1461191 C33.9999336,25.5594004 33.9999336,27.2659082 33.4191113,29.1031699 C32.6889746,31.1089375 31.1089375,32.6889746 29.1031699,33.4189785 C27.2659082,33.9999336 25.5594004,33.9999336 22.1461191,33.9999336 L11.8538809,33.9999336 C8.44059961,33.9999336 6.73402539,33.9999336 4.89689648,33.4189785 C2.8910625,32.6889746 1.31102539,31.1089375 0.580955078,29.1031699 C6.640625e-05,27.2659082 6.640625e-05,25.5594004 6.640625e-05,22.1461191 L6.640625e-05,11.8538809 C6.640625e-05,8.44059961 6.640625e-05,6.73402539 0.580955078,4.89689648 C1.31102539,2.8910625 2.8910625,1.31102539 4.89689648,0.580955078 C6.73402539,6.640625e-05 8.44059961,6.640625e-05 11.8538809,6.640625e-05 L11.8538809,6.640625e-05"
          fill="url(#castro-linearGradient-1)"
        />
        <path
          d="M17.0166016,2.22460938 C25.185998,2.22460938 31.8085937,8.84069727 31.8085937,17.0020586 C31.8085937,25.1634531 25.185998,31.779541 17.0166016,31.779541 C8.84720508,31.779541 2.22460938,25.1634531 2.22460938,17.0020586 C2.22460938,8.84069727 8.84720508,2.22460938 17.0166016,2.22460938 Z"
          fill="url(#castro-linearGradient-2)"
        />
        <path
          d="M23.1715645,25.4293437 L20.6914902,21.9926543 C22.249082,20.8536211 23.2608809,19.0139023 23.2608809,16.9378105 C23.2608809,13.4801035 20.455084,10.6770957 16.9939238,10.6770957 C13.5327969,10.6770957 10.727,13.4801035 10.727,16.9378105 C10.727,19.023 11.7476973,20.8697578 13.316877,22.0075957 L10.8349434,25.4469414 C8.19662305,23.5391895 6.47985547,20.4378184 6.47985547,16.9354531 C6.47985547,11.1359961 11.1859336,6.43459961 16.991168,6.43459961 C22.7964023,6.43459961 27.5024805,11.1359961 27.5024805,16.9354531 C27.5024805,20.4270937 25.7961387,23.5201309 23.1715645,25.4293437 Z M17.0144766,14.4014238 C18.4110664,14.4014238 19.5432598,15.5324883 19.5432598,16.9276836 C19.5432598,18.3229121 18.4110664,19.4539434 17.0144766,19.4539434 C15.6178535,19.4539434 14.4856934,18.3229121 14.4856934,16.9276836 C14.4856934,15.5324883 15.6178535,14.4014238 17.0144766,14.4014238 Z"
          fill="#FFFFFF"
        />
      </g>
    </g>
  </svg>
);

export const RadioPublicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#CE262F" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>RadioPublic</title>
    <path d="M13.793 4.0692c3.0122-.2832 6.0245-1.9773 9.037-.5353v19.892c-4.1555-1.9892-8.3106 1.989-12.4656 0l-.0002-3.1517v-.3473c-3.0646.271-6.1294 1.988-9.1941.5392V.5742c4.2077 1.989 8.4155-1.989 12.6229 0zm2.2949 10.7988c.3625-.0852.725-.1737 1.0875-.2584 1.6054-.3793 2.2448-1.403 2.244-3.015V8.9974c.0004-1.5849-.4136-2.591-2.3648-2.1348-1.0875.2563-2.1747.5422-3.2626.6441v12.9706c.7652-.0717 1.5303-.2347 2.2959-.414zm0-2.1095V9.0973c.1435-.0335.2875-.068.431-.1023.5373-.1282.5864.1568.5876.6274-.0004.7207-.0004 1.441 0 2.1618-.0004.401-.0507.7437-.5876.872a82.0824 82.0824 0 0 1-.431.1023zm-9.148 4.3506v-5.5437c.1609-.0373.3223-.0754.4833-.1134.4667-.1102.6033.0151.6041.6253v3.7832c.0009.5754.0872.8338.2072.9464.7656-.1732 1.5304-.3227 2.2955-.3772v-.0872c-.0855-.1507-.1902-.3854-.1893-.9435v-4.4106c.0008-.9632-.622-1.3306-.9842-1.401.4303-.2724 1.019-.8019 1.0182-1.8793V5.6334c0-1.3907-.7072-2.1254-2.1057-1.8048-1.208.2724-2.4167.6057-3.625.7183v12.9705c.7655-.0712 1.5307-.2313 2.2958-.4083zm0-7.688V6.1437a73.198 73.198 0 0 0 .5177-.1217c.466-.1101.5693.041.5697.5988v1.761c0 .6101-.1715.8239-.6386.934-.1496.0353-.2993.071-.4489.1053z" />
  </svg>
);

export const CastboxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#F55B23" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Castbox</title>
    <path d="M12 0c-.29 0-.58.068-.812.206L2.417 5.392c-.46.272-.804.875-.804 1.408v10.4c0 .533.344 1.135.804 1.407l8.77 5.187c.465.275 1.162.275 1.626 0l8.77-5.187c.46-.272.804-.874.804-1.407V6.8c0-.533-.344-1.136-.804-1.408L12.813.206A1.618 1.618 0 0012 0zm-.85 8.304c.394 0 .714.303.714.676v2.224c0 .207.191.375.427.375s.428-.168.428-.375V9.57c0-.373.32-.675.713-.675.394 0 .712.302.712.675v4.713c0 .374-.318.676-.712.676-.394 0-.713-.302-.713-.676v-1.31c0-.206-.192-.374-.428-.374s-.427.168-.427.374v1.226c0 .374-.32.676-.713.676-.394 0-.713-.302-.713-.676v-1.667c0-.207-.192-.375-.428-.375-.235 0-.427.168-.427.375v3.31c0 .373-.319.676-.712.676-.394 0-.713-.303-.713-.676v-2.427c0-.206-.191-.374-.428-.374-.235 0-.427.168-.427.374v.178a.71.71 0 01-.712.708.71.71 0 01-.713-.708v-2.123a.71.71 0 01.713-.708.71.71 0 01.712.708v.178c0 .206.192.373.427.373.237 0 .428-.167.428-.373v-1.53c0-.374.32-.676.713-.676.393 0 .712.303.712.676v.646c0 .206.192.374.427.374.236 0 .428-.168.428-.374V8.98c0-.373.319-.676.713-.676zm4.562 2.416c.393 0 .713.302.713.676v2.691c0 .374-.32.676-.713.676-.394 0-.712-.303-.712-.676v-2.691c0-.374.319-.676.712-.676zm2.28 1.368c.395 0 .713.303.713.676v.67c0 .374-.318.676-.712.676-.394 0-.713-.302-.713-.675v-.67c0-.374.32-.677.713-.677Z" />
  </svg>
);

export const PandoraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Pandora</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#224099" fillRule="nonzero">
        <path d="M19.051,0 L4.949,0 C2.25,0 0,2.221 0,4.95 L0,19.051 C0,21.75 2.22,24 4.949,24 L19.051,24 C21.779,24 24,21.779 24,19.051 L24,4.95 C24,2.25 21.779,0 19.051,0 Z M12.375,15.811 L11.146,15.811 L11.146,18.6 C11.146,18.961 10.845,19.246 10.5,19.246 L6.646,19.246 L6.646,4.756 L13.2,4.756 C16.381,4.756 18.842,6.406 18.842,10.156 C18.842,13.711 16.112,15.81 12.391,15.81 L12.375,15.81 L12.375,15.811 Z" />
      </g>
    </g>
  </svg>
);

export const PodcastAddictIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#F4842D" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Podcast Addict</title>
    <path d="M5.36.037C2.41.037 0 2.447 0 5.397v13.207c0 2.95 2.41 5.36 5.36 5.36h13.28c2.945 0 5.36-2.41 5.36-5.36V5.396c0-2.95-2.415-5.36-5.36-5.36zm6.585 4.285a7.72 7.72 0 017.717 7.544l.005 7.896h-3.39v-1.326a7.68 7.68 0 01-4.327 1.326 7.777 7.777 0 01-2.384-.378v-4.63a3.647 3.647 0 002.416.91 3.666 3.666 0 003.599-2.97h-1.284a2.416 2.416 0 01-4.73-.66v-.031c0-1.095.728-2.023 1.728-2.316V8.403a3.67 3.67 0 00-2.975 3.6v6.852a7.72 7.72 0 013.625-14.533zm.031 1.87V7.43h.006a4.575 4.575 0 014.573 4.574v.01h1.237v-.01a5.81 5.81 0 00-5.81-5.81zm0 2.149v1.246h.006a2.413 2.413 0 012.415 2.416v.01h1.247v-.01a3.662 3.662 0 00-3.662-3.662zm0 2.252c-.78 0-1.409.629-1.409 1.41 0 .78.629 1.409 1.41 1.409.78 0 1.409-.629 1.409-1.41 0-.78-.629-1.409-1.41-1.409z" />
  </svg>
);

export const PlayerFMIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg role="img" fill="#C8122A" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Player FM</title>
    <path d="M11.976 0a12 12 0 00-.347.012c-.323.021-.771.063-1.129.11-3.29.448-6.096 2.1-7.993 4.56a12.027 12.027 0 00-1.22 1.94 12 12 0 00-.173.358c-.092.198-.179.4-.261.603a12 12 0 00-.288.788l-.045.143A12 12 0 000 11.986v.037A12 12 0 0012 24a12 12 0 0011.939-10.79l.003-.024A12 12 0 0024 12.018v-.048a12 12 0 00-.769-4.182c-.04-.105-.081-.21-.125-.313a12 12 0 00-.226-.507c-1.487-3.15-4.299-5.59-7.698-6.506-.76-.208-1.978-.39-2.813-.444A12 12 0 0012.024 0h-.048zm2.321 2.88c.166.001.377.056.675.159 1.782.611 3.773 2.157 4.856 3.764.752 1.118 1.337 2.428 1.337 2.987 0 .358-.35.681-.725.681-.35 0-.708-.305-.804-.68-.13-.525-.83-1.852-1.345-2.534-.917-1.205-2.332-2.262-3.72-2.777-.979-.367-1.232-.795-.778-1.336.152-.182.29-.267.504-.265zm-3.885 1.4c.26.001.495.056.7.165 1.31.664 1.24 2.568-.122 3.092-1.686.637-2.533 1.319-3.084 2.437-1.153 2.34-.21 5.1 2.123 6.218 1.712.821 3.668.533 5.03-.725.62-.576.961-1.074 1.267-1.878.428-1.126.917-1.545 1.79-1.545 1.119 0 1.887.943 1.66 2.026-.463 2.13-2.253 4.27-4.42 5.275-1.196.55-1.851.69-3.362.69-1.485 0-2.131-.131-3.284-.655-3.144-1.424-5.075-4.83-4.673-8.21a8.123 8.123 0 015.511-6.734c.315-.105.603-.157.864-.156zm3.463.96c.217.004.499.105.914.306 1.686.803 3.083 2.279 3.834 4.035.28.672.14 1.109-.41 1.283-.42.123-.7-.104-1.066-.864-.681-1.441-1.65-2.437-3.013-3.11-.795-.384-.891-.471-.97-.847-.035-.2 0-.314.184-.532.157-.184.31-.276.527-.271zm-.398 2.443c.23-.001.496.108.84.334.961.629 2.044 1.983 2.044 2.55 0 .289-.28.656-.559.725-.376.097-.646-.087-1.04-.707-.427-.655-.925-1.153-1.44-1.415-.446-.227-.577-.402-.577-.769a.58.58 0 01.245-.515.727.727 0 01.487-.203z" />
  </svg>
);

export const StitcherIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 122.88 51.61"
    xmlSpace="preserve"
    {...props}
  >
    <title>Stitcher</title>
    <g>
      <polygon
        className="st9"
        points="0,10.14 21.5,10.14 21.5,49.15 0,49.15 0,10.14"
        fill="#3590C5"
      />
      <polygon
        className="st6"
        points="101.38,7.99 122.88,7.99 122.88,43.93 101.38,43.93 101.38,7.99"
        fill="#C53827"
      />
      <polygon
        className="st5"
        points="76.19,0 97.69,0 97.69,46.7 76.19,46.7 76.19,0"
        fill="#EC8B24"
      />
      <polygon
        className="st7"
        points="51,6.76 72.5,6.76 72.5,51.61 51,51.61 51,6.76"
        fill="#FBC618"
      />
      <polygon
        className="st8"
        points="25.5,3.07 47,3.07 47,46.39 25.5,46.39 25.5,3.07"
        fill="#612268"
      />
    </g>
  </svg>
);

export const DeezerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 250 163.17" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <linearGradient
        id="deezer-e"
        x1="90.71"
        x2="90.5"
        y1="62.45"
        y2="49.29"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#358c7b" offset="0" />
        <stop stopColor="#33a65e" offset=".5256" />
      </linearGradient>
      <linearGradient
        id="deezer-a"
        x1="79.29"
        x2="101.91"
        y1="79.49"
        y2="67.97"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222b90" offset="0" />
        <stop stopColor="#367b99" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-b"
        x2="21.95"
        y1="91.55"
        y2="91.55"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#f90" offset="0" />
        <stop stopColor="#ff8000" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-h"
        x1="26.55"
        x2="48.49"
        y1="91.55"
        y2="91.55"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ff8000" offset="0" />
        <stop stopColor="#cc1953" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-g"
        x1="53.09"
        x2="75.03"
        y1="91.55"
        y2="91.55"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#cc1953" offset="0" />
        <stop stopColor="#241284" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-i"
        x1="79.6"
        x2="101.55"
        y1="91.55"
        y2="91.55"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222b90" offset="0" />
        <stop stopColor="#3559a6" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-c"
        x1="52.22"
        x2="75.9"
        y1="77.19"
        y2="70.27"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#cc1953" offset="0" />
        <stop stopColor="#241284" offset="1" />
      </linearGradient>
      <linearGradient
        id="deezer-f"
        x1="25.76"
        x2="49.27"
        y1="69.45"
        y2="78.01"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fc0" offset=".0026698" />
        <stop stopColor="#ce1938" offset=".9999" />
      </linearGradient>
      <linearGradient
        id="deezer-d"
        x1="28.39"
        x2="46.65"
        y1="47.49"
        y2="64.33"
        gradientTransform="matrix(2.4611 0 0 2.4611 0 -77.943)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ffd100" offset=".0026698" />
        <stop stopColor="#fd5a22" offset="1" />
      </linearGradient>
    </defs>
    <path d="m250 0v31.625h-54.046v-31.625h54.046z" fill="#40ab5d" strokeWidth="2.4611" />
    <path
      d="m250 43.832v31.625h-54.046v-31.625h54.046z"
      fill="url(#deezer-e)"
      strokeWidth="2.4611"
    />
    <path
      d="m250 87.69v31.625h-54.046v-31.625h54.046z"
      fill="url(#deezer-a)"
      strokeWidth="2.4611"
    />
    <path
      d="m54.046 131.55v31.625h-54.046v-31.625h54.046z"
      fill="url(#deezer-b)"
      strokeWidth="2.4611"
    />
    <path
      d="m119.34 131.55v31.625h-54.071v-31.625h54.071z"
      fill="url(#deezer-h)"
      strokeWidth="2.4611"
    />
    <path
      d="m184.73 131.55v31.625h-54.071v-31.625h54.071z"
      fill="url(#deezer-g)"
      strokeWidth="2.4611"
    />
    <path
      d="m250 131.55v31.625h-54.046v-31.625h54.046z"
      fill="url(#deezer-i)"
      strokeWidth="2.4611"
    />
    <path
      d="m184.73 87.69v31.625h-54.071v-31.625h54.071z"
      fill="url(#deezer-c)"
      strokeWidth="2.4611"
    />
    <path
      d="m119.34 87.69v31.625h-54.071v-31.625h54.071z"
      fill="url(#deezer-f)"
      strokeWidth="2.4611"
    />
    <path
      d="m119.34 43.832v31.625h-54.071v-31.625h54.071z"
      fill="url(#deezer-d)"
      strokeWidth="2.4611"
    />
  </svg>
);

export const HeadphonesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    width="20px"
    height="20px"
    className="icon-headphones"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <title>headphones</title>
    <g>
      <path d="M7,12a3,3,0,0,0-3,3v6a3,3,0,0,0,6,0V15A3,3,0,0,0,7,12Zm10,0a3,3,0,0,0-3,3v6a3,3,0,0,0,6,0V15A3,3,0,0,0,17,12ZM12,0A12,12,0,0,0,0,12v5a1,1,0,0,0,2,0V12a10,10,0,0,1,20,0v5a1,1,0,0,0,2,0V12A12,12,0,0,0,12,0Z" />
    </g>
  </svg>
);

export function ArrowLeftIcon({
  width = 14,
  height = 14,
  fill = '#D2B7F9',
}: {
  width?: number;
  height?: number;
  fill?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={`${height}px`}
      width={`${width}px`}
      viewBox="0 -960 960 960"
      fill={fill}
    >
      <path d="M630-444H192v-72h438L429-717l51-51 288 288-288 288-51-51 201-201Z" />
    </svg>
  );
}

export function BackArrowIcon({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1875 12C3.1875 11.6893 3.43934 11.4375 3.75 11.4375H20.25C20.5607 11.4375 20.8125 11.6893 20.8125 12C20.8125 12.3107 20.5607 12.5625 20.25 12.5625H3.75C3.43934 12.5625 3.1875 12.3107 3.1875 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8977 4.85225C11.1174 5.07192 11.1174 5.42808 10.8977 5.64775L4.54549 12L10.8977 18.3523C11.1174 18.5719 11.1174 18.9281 10.8977 19.1477C10.6781 19.3674 10.3219 19.3674 10.1023 19.1477L3.35225 12.3977C3.13258 12.1781 3.13258 11.8219 3.35225 11.6023L10.1023 4.85225C10.3219 4.63258 10.6781 4.63258 10.8977 4.85225Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MenuIcon({
  width = 24,
  height = 24,
  fill = '#D2B7F9',
}: {
  width?: number;
  height?: number;
  fill?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={`${height}px`}
      width={`${width}px`}
      viewBox="0 -960 960 960"
      fill={fill}
    >
      <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
    </svg>
  );
}

export const PricingTickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24.5663 1.13208C25.2399 1.78491 25.2399 2.84509 24.5663 3.49793L10.7719 16.8679C10.0983 17.5207 9.0045 17.5207 8.33094 16.8679L1.43375 10.1829C0.7602 9.53008 0.7602 8.46988 1.43375 7.81705C2.1073 7.16421 3.20116 7.16421 3.8747 7.81705L9.55411 13.3165L22.1307 1.13208C22.8042 0.479249 23.8981 0.479249 24.5717 1.13208H24.5663Z"
      fill="currentColor"
    />
  </svg>
);

export const ExternalLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.1667V0H6.76271V1.25H1.25V12.9167H12.9167V7.40396H14.1667V14.1667H0ZM5.18271 9.86208L4.30458 8.98396L12.0385 1.25H8.75V0H14.1667V5.41667H12.9167V2.12813L5.18271 9.86208Z"
      fill="currentColor"
      fillOpacity="0.45"
    />
  </svg>
);

export function ThemeLightIcon({
  width = 20,
  height = 20,
  fill = 'none',
}: {
  width?: number;
  height?: number;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.83979 17.6796L6.22271 15.0898H2.58979V11.4569L0 8.83979L2.58979 6.22271V2.58979H6.22271L8.83979 0L11.4569 2.58979H15.0898V6.22271L17.6796 8.83979L15.0898 11.4569V15.0898H11.4569L8.83979 17.6796ZM8.83979 12.6858C9.90174 12.6858 10.8083 12.3108 11.5594 11.5608C12.3103 10.8108 12.6858 9.90382 12.6858 8.83979C12.6858 7.77576 12.3108 6.86875 11.5608 6.11875C10.8108 5.36875 9.90382 4.99375 8.83979 4.99375V12.6858ZM8.83979 15.9231L10.9231 13.8398H13.8398V10.9231L15.9231 8.83979L13.8398 6.75646V3.83979H10.9231L8.83979 1.75646L6.75646 3.83979H3.83979V6.75646L1.75646 8.83979L3.83979 10.9231V13.8398H6.75646L8.83979 15.9231Z"
        fill="currentColor"
        // fillOpacity="0.45"
      />
    </svg>
  );
}

export const CertificateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.59863 12.8678H16.932V11.0249H3.59863V12.8678ZM7.38072 17.9799V14.1178H2.34863V2.45117H18.182V14.1178H13.1499V17.9799L10.2653 16.5376L7.38072 17.9799ZM3.59863 8.87742H16.932V3.70117H3.59863V8.87742Z" />
    </svg>
  );
};
export function UploadIcon({
  className = '',
  size = 20,
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.72093C3 5.04663 3.55306 4.5 4.23529 4.5H19.7647C20.4469 4.5 21 5.04663 21 5.72093V18.2791C21 18.9534 20.4469 19.5 19.7647 19.5H4.23529C3.55306 19.5 3 18.9534 3 18.2791V5.72093ZM4.05882 5.72093C4.05882 5.6246 4.13783 5.54651 4.23529 5.54651H19.7647C19.8622 5.54651 19.9412 5.6246 19.9412 5.72093V15.6205L17.1154 12.8276L17.1137 12.8259C16.9991 12.7114 16.8627 12.6203 16.7124 12.5581C16.5613 12.4956 16.3991 12.4634 16.2353 12.4634C16.0715 12.4634 15.9093 12.4956 15.7582 12.5581C15.6078 12.6203 15.4714 12.7114 15.3569 12.8259L15.3551 12.8276L13.5404 14.6213L13.5375 14.6241C13.5211 14.6406 13.5015 14.6537 13.4799 14.6626C13.4583 14.6716 13.4352 14.6762 13.4118 14.6762C13.3884 14.6762 13.3652 14.6716 13.3436 14.6626C13.322 14.6537 13.3025 14.6406 13.286 14.6241L13.2832 14.6213L9.34915 10.733C9.23453 10.6184 9.09809 10.5273 8.94768 10.4651C8.79658 10.4026 8.6344 10.3704 8.47059 10.3704C8.30678 10.3704 8.1446 10.4026 7.9935 10.4651C7.8431 10.5273 7.70667 10.6184 7.59206 10.733L4.05882 14.2251V5.72093ZM4.05882 15.7051L8.342 11.4717L8.34485 11.4689C8.36127 11.4524 8.38085 11.4393 8.40243 11.4304C8.42402 11.4215 8.44719 11.4169 8.47059 11.4169C8.49399 11.4169 8.51716 11.4215 8.53874 11.4304C8.56033 11.4393 8.5799 11.4524 8.59632 11.4689L8.59918 11.4717L12.5332 15.36C12.6478 15.4746 12.7843 15.5657 12.9347 15.6279C13.0858 15.6905 13.248 15.7227 13.4118 15.7227C13.5756 15.7227 13.7378 15.6905 13.8889 15.6279C14.0393 15.5657 14.1757 15.4746 14.2903 15.36L14.2919 15.3584L16.1067 13.5648L16.1096 13.5619C16.126 13.5455 16.1456 13.5324 16.1671 13.5234C16.1887 13.5145 16.2119 13.5099 16.2353 13.5099C16.2587 13.5099 16.2819 13.5145 16.3034 13.5234C16.325 13.5324 16.3446 13.5455 16.361 13.5619L16.3639 13.5648L19.9412 17.1005V18.2791C19.9412 18.3754 19.8622 18.4535 19.7647 18.4535H4.23529C4.13783 18.4535 4.05882 18.3754 4.05882 18.2791V15.7051Z"
        fill="currentColor"
      />
      <path
        d="M14.4706 10.4302C14.9579 10.4302 15.3529 10.0398 15.3529 9.55814C15.3529 9.0765 14.9579 8.68605 14.4706 8.68605C13.9833 8.68605 13.5882 9.0765 13.5882 9.55814C13.5882 10.0398 13.9833 10.4302 14.4706 10.4302Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SaveIcon({
  className = '',
  size = 20,
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2498 3.63834C4.2766 3.61378 4.32103 3.59375 4.375 3.59375H12.5389C12.5825 3.59375 12.6241 3.61197 12.6537 3.64402L15.7398 6.98734C15.7665 7.0162 15.7812 7.05404 15.7812 7.09332V16.3021C15.7812 16.3159 15.7756 16.3383 15.7502 16.3617C15.7234 16.3862 15.679 16.4062 15.625 16.4062H13.5827C13.59 16.3552 13.5938 16.3031 13.5938 16.25V12.5C13.5938 11.8959 13.1041 11.4062 12.5 11.4062H7.5C6.89594 11.4062 6.40625 11.8959 6.40625 12.5V16.25C6.40625 16.3031 6.41003 16.3552 6.41733 16.4062H4.375C4.32103 16.4062 4.2766 16.3862 4.2498 16.3617C4.22437 16.3383 4.21875 16.3159 4.21875 16.3021V3.69792C4.21875 3.6841 4.22437 3.66166 4.2498 3.63834ZM7.5 16.4062H12.5C12.5863 16.4062 12.6562 16.3363 12.6562 16.25V12.5C12.6562 12.4137 12.5863 12.3438 12.5 12.3438H7.5C7.41371 12.3438 7.34375 12.4137 7.34375 12.5V16.25C7.34375 16.3363 7.41371 16.4062 7.5 16.4062ZM4.375 17.3438C4.09745 17.3438 3.82393 17.2431 3.61631 17.0527C3.40733 16.8612 3.28125 16.5922 3.28125 16.3021V3.69792C3.28125 3.40784 3.40733 3.13883 3.61631 2.94726C3.82393 2.75694 4.09745 2.65625 4.375 2.65625H12.5389C12.8441 2.65625 13.1355 2.78382 13.3425 3.00813L16.4287 6.35145C16.6152 6.55349 16.7188 6.81837 16.7188 7.09332V16.3021C16.7188 16.5922 16.5927 16.8612 16.3837 17.0527C16.1761 17.2431 15.9026 17.3438 15.625 17.3438H4.375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 6.40625C7.5 6.14737 7.70987 5.9375 7.96875 5.9375H12.0312C12.2901 5.9375 12.5 6.14737 12.5 6.40625C12.5 6.66513 12.2901 6.875 12.0312 6.875H7.96875C7.70987 6.875 7.5 6.66513 7.5 6.40625Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AskAiIcon({ width = 20, height = 20 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99982 8.99963L12.75 10.875L8.99982 12.7498L7.125 16.5L5.24963 12.7498L1.5 10.875L5.24963 8.99963L7.125 5.25L8.99982 8.99963Z"
        fill="currentColor"
      />
      <path
        d="M14.2499 3.78787L16.5 4.91309L14.2499 6.03798L13.125 8.28809L11.9998 6.03798L9.75 4.91309L11.9998 3.78787L13.125 1.53809L14.2499 3.78787Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HamburgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.4375 7.5C5.4375 7.18934 5.68934 6.9375 6 6.9375H18C18.3107 6.9375 18.5625 7.18934 18.5625 7.5C18.5625 7.81066 18.3107 8.0625 18 8.0625H6C5.68934 8.0625 5.4375 7.81066 5.4375 7.5Z"
        fill="#475161"
      />
      <path
        d="M5.4375 12C5.4375 11.6893 5.68934 11.4375 6 11.4375H18C18.3107 11.4375 18.5625 11.6893 18.5625 12C18.5625 12.3107 18.3107 12.5625 18 12.5625H6C5.68934 12.5625 5.4375 12.3107 5.4375 12Z"
        fill="#475161"
      />
      <path
        d="M6 15.9375C5.68934 15.9375 5.4375 16.1893 5.4375 16.5C5.4375 16.8107 5.68934 17.0625 6 17.0625H18C18.3107 17.0625 18.5625 16.8107 18.5625 16.5C18.5625 16.1893 18.3107 15.9375 18 15.9375H6Z"
        fill="#475161"
      />
    </svg>
  );
}

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.58337 17.181V3.22266H15.4167V17.181L10 14.8545L4.58337 17.181ZM5.83337 15.2643L10 13.4727L14.1667 15.2643V4.47266H5.83337V15.2643Z"
        fill="white"
        fillOpacity="0.45"
      />
    </svg>
  );
}

export const LinkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00662 13.7817H5.86558C4.81919 13.7817 3.92725 13.4129 3.18975 12.6754C2.45225 11.9381 2.0835 11.0463 2.0835 10C2.0835 8.95378 2.45225 8.06183 3.18975 7.3242C3.92725 6.58642 4.81919 6.21753 5.86558 6.21753H9.00662V7.46753H5.86558C5.16572 7.46753 4.56877 7.71461 4.07475 8.20878C3.58058 8.70295 3.3335 9.29989 3.3335 9.99961C3.3335 10.6993 3.58058 11.2963 4.07475 11.7904C4.56877 12.2846 5.16572 12.5317 5.86558 12.5317H9.00662V13.7817ZM6.87516 10.6246V9.37461H13.1252V10.6246H6.87516ZM10.9937 13.7817V12.5317H14.1347C14.8346 12.5317 15.4316 12.2846 15.9256 11.7904C16.4197 11.2963 16.6668 10.6993 16.6668 9.99961C16.6668 9.29989 16.4197 8.70295 15.9256 8.20878C15.4316 7.71461 14.8346 7.46753 14.1347 7.46753H10.9937V6.21753H14.1347C15.1811 6.21753 16.0731 6.58628 16.8106 7.32378C17.5481 8.06114 17.9168 8.95295 17.9168 9.9992C17.9168 11.0454 17.5481 11.9374 16.8106 12.675C16.0731 13.4128 15.1811 13.7817 14.1347 13.7817H10.9937Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const ResourceDownloadIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0001 14.4665L7.86676 10.3332L9.3501 8.84985L10.9501 10.4665V6.09985H13.0501V10.4665L14.6501 8.84985L16.1334 10.3332L12.0001 14.4665ZM6.1001 17.8999V13.7999H8.2001V15.7999H15.8001V13.7999H17.9001V17.8999H6.1001Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export function CheckmarkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
}

export function CheckCircleIcon({ className = '', size = 24, strokeWidth = 2 }: LucideIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function ClockIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.81697 15.545L14.4195 9.94245L13.5413 9.06433L8.81697 13.7887L6.44197 11.4137L5.56384 12.2918L8.81697 15.545ZM10.0011 19.9168C8.90613 19.9168 7.8769 19.7091 6.91342 19.2935C5.94995 18.8779 5.1119 18.314 4.39926 17.6016C3.68662 16.8893 3.12238 16.0516 2.70655 15.0885C2.29085 14.1254 2.08301 13.0965 2.08301 12.0016C2.08301 10.9066 2.29079 9.87738 2.70634 8.91391C3.1219 7.95044 3.68586 7.11238 4.39822 6.39975C5.11058 5.68711 5.94829 5.12287 6.91134 4.70704C7.8744 4.29134 8.90335 4.0835 9.99822 4.0835C11.0932 4.0835 12.1225 4.29127 13.0859 4.70683C14.0494 5.12238 14.8875 5.68634 15.6001 6.3987C16.3127 7.11107 16.877 7.94877 17.2928 8.91183C17.7085 9.87489 17.9163 10.9038 17.9163 11.9987C17.9163 13.0937 17.7086 14.1229 17.293 15.0864C16.8775 16.0499 16.3135 16.8879 15.6011 17.6006C14.8888 18.3132 14.0511 18.8775 13.088 19.2933C12.125 19.709 11.096 19.9168 10.0011 19.9168ZM9.99967 18.6668C11.8608 18.6668 13.4372 18.021 14.7288 16.7293C16.0205 15.4377 16.6663 13.8613 16.6663 12.0002C16.6663 10.1391 16.0205 8.56266 14.7288 7.271C13.4372 5.97933 11.8608 5.3335 9.99967 5.3335C8.13856 5.3335 6.56217 5.97933 5.27051 7.271C3.97884 8.56266 3.33301 10.1391 3.33301 12.0002C3.33301 13.8613 3.97884 15.4377 5.27051 16.7293C6.56217 18.021 8.13856 18.6668 9.99967 18.6668Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
}

export const BookmarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.58301 19.181V5.22266H15.4163V19.181L9.99967 16.8545L4.58301 19.181ZM5.83301 17.2643L9.99967 15.4727L14.1663 17.2643V6.47266H5.83301V17.2643Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const BookmarkFilledIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.58301 19.181V5.22266H15.4163V19.181L9.99967 16.8545L4.58301 19.181Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const CompleteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.81697 15.545L14.4195 9.94245L13.5413 9.06433L8.81697 13.7887L6.44197 11.4137L5.56384 12.2918L8.81697 15.545ZM10.0011 19.9168C8.90613 19.9168 7.8769 19.7091 6.91342 19.2935C5.94995 18.8779 5.1119 18.314 4.39926 17.6016C3.68662 16.8893 3.12238 16.0516 2.70655 15.0885C2.29085 14.1254 2.08301 13.0965 2.08301 12.0016C2.08301 10.9066 2.29079 9.87738 2.70634 8.91391C3.1219 7.95044 3.68586 7.11238 4.39822 6.39975C5.11058 5.68711 5.94829 5.12287 6.91134 4.70704C7.8744 4.29134 8.90335 4.0835 9.99822 4.0835C11.0932 4.0835 12.1225 4.29127 13.0859 4.70683C14.0494 5.12238 14.8875 5.68634 15.6001 6.3987C16.3127 7.11107 16.877 7.94877 17.2928 8.91183C17.7085 9.87489 17.9163 10.9038 17.9163 11.9987C17.9163 13.0937 17.7086 14.1229 17.293 15.0864C16.8775 16.0499 16.3135 16.8879 15.6011 17.6006C14.8888 18.3132 14.0511 18.8775 13.088 19.2933C12.125 19.709 11.096 19.9168 10.0011 19.9168ZM9.99967 18.6668C11.8608 18.6668 13.4372 18.021 14.7288 16.7293C16.0205 15.4377 16.6663 13.8613 16.6663 12.0002C16.6663 10.1391 16.0205 8.56266 14.7288 7.271C13.4372 5.97933 11.8608 5.3335 9.99967 5.3335C8.13856 5.3335 6.56217 5.97933 5.27051 7.271C3.97884 8.56266 3.33301 10.1391 3.33301 12.0002C3.33301 13.8613 3.97884 15.4377 5.27051 16.7293C6.56217 18.021 8.13856 18.6668 9.99967 18.6668Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const PlayVideoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.12467 15.3656L13.3651 12.0002L8.12467 8.63475V15.3656ZM10.0011 19.9168C8.90613 19.9168 7.8769 19.7091 6.91342 19.2935C5.94995 18.8779 5.1119 18.314 4.39926 17.6016C3.68662 16.8893 3.12238 16.0516 2.70655 15.0885C2.29085 14.1254 2.08301 13.0965 2.08301 12.0016C2.08301 10.9066 2.29079 9.87738 2.70634 8.91391C3.1219 7.95044 3.68586 7.11238 4.39822 6.39975C5.11058 5.68711 5.94829 5.12287 6.91134 4.70704C7.8744 4.29134 8.90335 4.0835 9.99822 4.0835C11.0932 4.0835 12.1225 4.29127 13.0859 4.70683C14.0494 5.12238 14.8875 5.68634 15.6001 6.3987C16.3127 7.11107 16.877 7.94877 17.2928 8.91183C17.7085 9.87489 17.9163 10.9038 17.9163 11.9987C17.9163 13.0937 17.7086 14.1229 17.293 15.0864C16.8775 16.0499 16.3135 16.8879 15.6011 17.6006C14.8888 18.3132 14.0511 18.8775 13.088 19.2933C12.125 19.709 11.096 19.9168 10.0011 19.9168ZM9.99967 18.6668C11.8608 18.6668 13.4372 18.021 14.7288 16.7293C16.0205 15.4377 16.6663 13.8613 16.6663 12.0002C16.6663 10.1391 16.0205 8.56266 14.7288 7.271C13.4372 5.97933 11.8608 5.3335 9.99967 5.3335C8.13856 5.3335 6.56217 5.97933 5.27051 7.271C3.97884 8.56266 3.33301 10.1391 3.33301 12.0002C3.33301 13.8613 3.97884 15.4377 5.27051 16.7293C6.56217 18.021 8.13856 18.6668 9.99967 18.6668Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const EditIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.91663 17.0821V2.91548H11.6362L10.3862 4.16548H4.16663V15.8321H15.8333V9.55965L17.0833 8.30965V17.0821H2.91663ZM7.91663 12.0821V9.22152L16.3702 0.768188L19.1923 3.60131L10.737 12.0821H7.91663ZM9.16663 10.8321H10.2052L15.3989 5.63819L14.8798 5.11902L14.3237 4.58381L9.16663 9.7409V10.8321Z"
        fill="currentColor"
        fillOpacity="0.7"
      />
    </svg>
  );
};

export const ReplayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.16667 16.6095C7.60361 16.4064 6.31007 15.7179 5.28604 14.5439C4.26201 13.3697 3.75 11.9941 3.75 10.4172C3.75 9.56996 3.91722 8.7583 4.25167 7.98219C4.58611 7.20594 5.05458 6.52399 5.65708 5.93635L6.54812 6.8274C6.03632 7.29434 5.65035 7.83628 5.39021 8.45323C5.13007 9.07017 5 9.72483 5 10.4172C5 11.6394 5.39021 12.7166 6.17062 13.6489C6.95104 14.5809 7.94972 15.1511 9.16667 15.3595V16.6095ZM10.8333 16.6255V15.3755C12.0364 15.1319 13.0316 14.5489 13.819 13.6264C14.6063 12.7039 15 11.6341 15 10.4172C15 9.0283 14.5139 7.84774 13.5417 6.87552C12.5694 5.9033 11.3889 5.41719 10 5.41719H9.70521L10.8302 6.54219L9.95188 7.42031L7.32375 4.79219L9.95188 2.16406L10.8302 3.04219L9.70521 4.16719H10C11.7436 4.16719 13.2212 4.77295 14.4327 5.98448C15.6442 7.19601 16.25 8.67358 16.25 10.4172C16.25 11.9855 15.7367 13.3541 14.71 14.523C13.6832 15.6918 12.391 16.3926 10.8333 16.6255Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const ResumeVideoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.55047 13.404L13.0696 10.3913L8.55047 7.37857V13.404ZM10.0569 18.3079C8.9629 18.3079 7.93436 18.1012 6.9713 17.6877C6.00811 17.2743 5.17019 16.7112 4.45755 15.9986C3.74491 15.2861 3.18054 14.4495 2.76443 13.489C2.34831 12.5286 2.14026 11.5013 2.14026 10.4073C2.14026 9.85815 2.19477 9.31808 2.3038 8.78711C2.41269 8.25614 2.57186 7.7385 2.7813 7.23419L3.75234 8.20544C3.63595 8.56655 3.54651 8.92815 3.48401 9.29024C3.42151 9.65246 3.39026 10.0195 3.39026 10.3913C3.39026 12.2524 4.03609 13.8288 5.32776 15.1204C6.61943 16.4121 8.19581 17.0579 10.0569 17.0579C11.918 17.0579 13.4944 16.4121 14.7861 15.1204C16.0778 13.8288 16.7236 12.2524 16.7236 10.3913C16.7236 8.53016 16.0778 6.95378 14.7861 5.66211C13.4944 4.37044 11.918 3.72461 10.0569 3.72461C9.68193 3.72461 9.3147 3.75586 8.95526 3.81836C8.59568 3.88086 8.23963 3.9703 7.88713 4.08669L6.9288 3.12857C7.42561 2.91593 7.92637 2.75378 8.43109 2.64211C8.93595 2.53044 9.46186 2.47461 10.0088 2.47461C11.1082 2.47461 12.1422 2.68135 13.1107 3.09482C14.0791 3.50829 14.9223 4.07266 15.6403 4.78794C16.3582 5.50322 16.9265 6.34246 17.3453 7.30565C17.7641 8.26871 17.9736 9.29725 17.9736 10.3913C17.9736 11.4853 17.7655 12.5138 17.3494 13.4769C16.9333 14.4401 16.3689 15.278 15.6563 15.9907C14.9437 16.7033 14.1057 17.2677 13.1426 17.6838C12.1795 18.0999 11.151 18.3079 10.0569 18.3079ZM4.81651 6.1444C4.54415 6.1444 4.31047 6.04697 4.11547 5.85211C3.92047 5.65711 3.82297 5.42336 3.82297 5.15086C3.82297 4.8785 3.92047 4.64482 4.11547 4.44982C4.31047 4.25482 4.54415 4.15732 4.81651 4.15732C5.08901 4.15732 5.32276 4.25482 5.51776 4.44982C5.71262 4.64482 5.81005 4.8785 5.81005 5.15086C5.81005 5.42336 5.71262 5.65711 5.51776 5.85211C5.32276 6.04697 5.08901 6.1444 4.81651 6.1444Z"
        fill="currentColor"
        fillOpacity="0.45"
      />
    </svg>
  );
};

export const ClipboardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.37578C3.65482 3.37578 3.375 3.6556 3.375 4.00078V13.0008C3.375 13.346 3.65482 13.6258 4 13.6258H12C12.3452 13.6258 12.625 13.346 12.625 13.0008V4.00078C12.625 3.6556 12.3452 3.37578 12 3.37578H10.1528V2.62578H12C12.7594 2.62578 13.375 3.24139 13.375 4.00078V13.0008C13.375 13.7602 12.7594 14.3758 12 14.3758H4C3.24061 14.3758 2.625 13.7602 2.625 13.0008V4.00078C2.625 3.24139 3.24061 2.62578 4 2.62578H5.84722V3.37578H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.175 3.00078C5.175 2.269 5.76822 1.67578 6.5 1.67578H9.5C10.2318 1.67578 10.825 2.269 10.825 3.00078C10.825 3.73256 10.2318 4.32578 9.5 4.32578H6.5C5.76822 4.32578 5.175 3.73256 5.175 3.00078ZM6.5 2.32578C6.12721 2.32578 5.825 2.62799 5.825 3.00078C5.825 3.37357 6.12721 3.67578 6.5 3.67578H9.5C9.87279 3.67578 10.175 3.37357 10.175 3.00078C10.175 2.62799 9.87279 2.32578 9.5 2.32578H6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.125 6.00078C5.125 5.79367 5.29289 5.62578 5.5 5.62578H10.5C10.7071 5.62578 10.875 5.79367 10.875 6.00078C10.875 6.20789 10.7071 6.37578 10.5 6.37578H5.5C5.29289 6.37578 5.125 6.20789 5.125 6.00078Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.125 11.0008C5.125 10.7937 5.29289 10.6258 5.5 10.6258H10.5C10.7071 10.6258 10.875 10.7937 10.875 11.0008C10.875 11.2079 10.7071 11.3758 10.5 11.3758H5.5C5.29289 11.3758 5.125 11.2079 5.125 11.0008Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.125 8.50078C5.125 8.29367 5.29289 8.12578 5.5 8.12578H10.5C10.7071 8.12578 10.875 8.29367 10.875 8.50078C10.875 8.70789 10.7071 8.87578 10.5 8.87578H5.5C5.29289 8.87578 5.125 8.70789 5.125 8.50078Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RotateCwIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9241 5.15155C18.0731 5.70769 17.7431 6.27933 17.187 6.42835L14.4756 7.15485C14.1195 7.25026 13.7535 7.03894 13.6581 6.68285C13.5627 6.32677 13.774 5.96075 14.1301 5.86534L15.8567 5.40269C14.3674 4.57733 12.6488 4.24966 10.9537 4.4744C9.12087 4.7174 7.42987 5.59101 6.17112 6.94519C4.91237 8.29937 4.16444 10.0496 4.05579 11.8953C3.94714 13.7409 4.48456 15.5668 5.57573 17.0593C6.6669 18.5518 8.24373 19.6178 10.0354 20.0742C11.827 20.5305 13.7217 20.3488 15.3939 19.5601C17.0661 18.7715 18.4115 17.4252 19.199 15.7524C19.9866 14.0797 20.1671 12.1849 19.7095 10.3936C19.6183 10.0364 19.8339 9.67291 20.1911 9.58168C20.5483 9.49045 20.9118 9.70604 21.003 10.0632C21.5373 12.1551 21.3265 14.3677 20.4069 16.3211C19.4872 18.2745 17.9161 19.8466 15.9633 20.7676C14.0106 21.6885 11.7981 21.9008 9.70585 21.3678C7.61363 20.8349 5.77227 19.5901 4.49803 17.8472C3.2238 16.1043 2.59622 13.9721 2.7231 11.8168C2.84997 9.6615 3.72338 7.61765 5.19331 6.03628C6.66323 4.45492 8.63793 3.43475 10.7782 3.15098C12.6666 2.90063 14.5798 3.23729 16.2617 4.10549L15.9081 2.78574C15.8127 2.42965 16.024 2.06364 16.3801 1.96822C16.7362 1.87281 17.1022 2.08413 17.1976 2.44022L17.9241 5.15155Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z"
        fill="#0469E3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1.46875C4.61675 1.46875 1.46875 4.61675 1.46875 8.5C1.46875 12.3833 4.61675 15.5312 8.5 15.5312C12.3833 15.5312 15.5312 12.3833 15.5312 8.5C15.5312 4.61675 12.3833 1.46875 8.5 1.46875ZM0.53125 8.5C0.53125 4.09898 4.09898 0.53125 8.5 0.53125C12.901 0.53125 16.4688 4.09898 16.4688 8.5C16.4688 12.901 12.901 16.4688 8.5 16.4688C4.09898 16.4688 0.53125 12.901 0.53125 8.5Z"
        fill="#475161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 4.73505C8.75888 4.73505 8.96875 4.94491 8.96875 5.2038V9.5788C8.96875 9.83768 8.75888 10.0475 8.5 10.0475C8.24112 10.0475 8.03125 9.83768 8.03125 9.5788V5.2038C8.03125 4.94491 8.24112 4.73505 8.5 4.73505Z"
        fill="white"
      />
      <path
        d="M9.28125 12.1426C9.28125 12.5741 8.93147 12.9238 8.5 12.9238C8.06853 12.9238 7.71875 12.5741 7.71875 12.1426C7.71875 11.7111 8.06853 11.3613 8.5 11.3613C8.93147 11.3613 9.28125 11.7111 9.28125 12.1426Z"
        fill="white"
      />
    </svg>
  );
};

export const PausePlayerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.83634 13.1252H9.08613V6.87516H7.83634V13.1252ZM10.9132 13.1252H12.163V6.87516H10.9132V13.1252ZM10.0011 17.9168C8.90613 17.9168 7.8769 17.7091 6.91342 17.2935C5.94995 16.8779 5.1119 16.314 4.39926 15.6016C3.68662 14.8893 3.12238 14.0516 2.70655 13.0885C2.29085 12.1254 2.08301 11.0965 2.08301 10.0016C2.08301 8.90662 2.29079 7.87738 2.70634 6.91391C3.1219 5.95044 3.68586 5.11238 4.39822 4.39975C5.11058 3.68711 5.94829 3.12287 6.91134 2.70704C7.8744 2.29134 8.90335 2.0835 9.99822 2.0835C11.0932 2.0835 12.1225 2.29127 13.0859 2.70683C14.0494 3.12238 14.8875 3.68634 15.6001 4.3987C16.3127 5.11107 16.877 5.94877 17.2928 6.91183C17.7085 7.87489 17.9163 8.90384 17.9163 9.9987C17.9163 11.0937 17.7086 12.1229 17.293 13.0864C16.8775 14.0499 16.3135 14.8879 15.6011 15.6006C14.8888 16.3132 14.0511 16.8775 13.088 17.2933C12.125 17.709 11.096 17.9168 10.0011 17.9168ZM9.99967 16.6668C11.8608 16.6668 13.4372 16.021 14.7288 14.7293C16.0205 13.4377 16.6663 11.8613 16.6663 10.0002C16.6663 8.13905 16.0205 6.56266 14.7288 5.271C13.4372 3.97933 11.8608 3.3335 9.99967 3.3335C8.13856 3.3335 6.56217 3.97933 5.27051 5.271C3.97884 6.56266 3.33301 8.13905 3.33301 10.0002C3.33301 11.8613 3.97884 13.4377 5.27051 14.7293C6.56217 16.021 8.13856 16.6668 9.99967 16.6668Z"
        fill="white"
        fill-opacity="0.45"
      />
    </svg>
  );
};

export const CeoSignatureIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="160"
      height="69"
      viewBox="0 0 160 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <rect width="160" height="69" fill="url(#pattern0_30674_3544)" />
      <defs>
        <pattern
          id="pattern0_30674_3544"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_30674_3544"
            transform="matrix(0.0037037 0 0 0.00862069 0 -0.103448)"
          />
        </pattern>
        <image
          id="image0_30674_3544"
          width="270"
          height="140"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const ContentstackLogo = (props: SVGProps<SVGAElement>) => {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.228 6.65949V9.41534L6.60024 10.3344L0 9.41534V6.65949L6.60024 5.74042L13.228 6.65949Z"
        fill="#AC75FF"
      />
      <path
        d="M0 13.0903V10.3344L3.85818 12.4013L13.228 10.3344V13.0903L3.85818 16.0762L0 13.0903Z"
        fill="#AC75FF"
      />
      <path
        d="M13.228 2.98596V5.7418L9.36987 3.67492L0 5.7418V2.98596L9.36987 0L13.228 2.98596Z"
        fill="#AC75FF"
      />
    </svg>
  );
};

export function BookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.54813 15.8333C1.8441 15.8333 1.2434 15.5847 0.746042 15.0873C0.248681 14.5899 0 13.9892 0 13.2852V2.70833C0 1.95625 0.263333 1.31681 0.79 0.79C1.31681 0.263333 1.95625 0 2.70833 0H12.5V11.9871C12.1421 11.9871 11.8363 12.114 11.5825 12.3677C11.3288 12.6215 11.2019 12.9273 11.2019 13.2852C11.2019 13.6431 11.3288 13.949 11.5825 14.2027C11.8363 14.4565 12.1421 14.5833 12.5 14.5833V15.8333H2.54813ZM1.25 11.1202C1.43917 10.9909 1.64188 10.8947 1.85813 10.8317C2.07451 10.7688 2.30451 10.7373 2.54813 10.7373H3.07687V1.25H2.70833C2.30764 1.25 1.96444 1.39292 1.67875 1.67875C1.39292 1.96444 1.25 2.30764 1.25 2.70833V11.1202ZM4.32688 10.7373H11.25V1.25H4.32688V10.7373ZM2.54813 14.5833H10.335C10.2142 14.3942 10.1201 14.1936 10.0529 13.9817C9.98555 13.7696 9.95187 13.5374 9.95187 13.2852C9.95187 13.047 9.9834 12.8184 10.0465 12.5994C10.1095 12.3803 10.2057 12.1763 10.335 11.9871H2.54813C2.17632 11.9871 1.86701 12.114 1.62021 12.3677C1.3734 12.6215 1.25 12.9273 1.25 13.2852C1.25 13.657 1.3734 13.9663 1.62021 14.2131C1.86701 14.4599 2.17632 14.5833 2.54813 14.5833Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ResetPasswordIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.41667 14.4454C3.85361 14.2424 2.56007 13.5538 1.53604 12.3798C0.512014 11.2056 0 9.83007 0 8.25313C0 7.4059 0.167222 6.59424 0.501667 5.81813C0.836111 5.04188 1.30458 4.35993 1.90708 3.77229L2.79812 4.66333C2.28632 5.13028 1.90035 5.67222 1.64021 6.28917C1.38007 6.90611 1.25 7.56076 1.25 8.25313C1.25 9.47535 1.64021 10.5526 2.42063 11.4848C3.20104 12.4169 4.19972 12.9871 5.41667 13.1954V14.4454ZM7.08333 14.4615V13.2115C8.28639 12.9678 9.2816 12.3848 10.069 11.4623C10.8563 10.5398 11.25 9.47007 11.25 8.25313C11.25 6.86424 10.7639 5.68368 9.79167 4.71146C8.81944 3.73924 7.63889 3.25313 6.25 3.25313H5.95521L7.08021 4.37813L6.20188 5.25625L3.57375 2.62813L6.20188 0L7.08021 0.878126L5.95521 2.00313H6.25C7.99361 2.00313 9.47118 2.60889 10.6827 3.82042C11.8942 5.03194 12.5 6.50951 12.5 8.25313C12.5 9.82146 11.9867 11.1901 10.96 12.359C9.93319 13.5277 8.64097 14.2285 7.08333 14.4615Z"
        fill="currentColor"
        fillOpacity="0.67"
      />
    </svg>
  );
}

export function PasswordVisibilityIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72 10.97C7.07 8.62 10.75 6.25 16 6.25c5.25 0 8.93 2.37 11.28 4.72a18.669 18.669 0 012.573 3.224 15.699 15.699 0 01.775 1.38l.04.085.012.025.003.007.002.003L30 16l.685.305v.001l-.002.003-.003.007-.011.025-.04.085a15.699 15.699 0 01-.775 1.38c-.555.88-1.4 2.051-2.574 3.224-2.35 2.35-6.03 4.72-11.28 4.72-5.25 0-8.93-2.37-11.28-4.72a18.669 18.669 0 01-2.573-3.224 15.729 15.729 0 01-.775-1.38 5.785 5.785 0 01-.041-.085l-.011-.025-.004-.007v-.003h-.001L2 16l-.685-.305v-.001l.001-.003.004-.007.011-.025.04-.085a15.729 15.729 0 01.775-1.38c.554-.88 1.4-2.051 2.574-3.224zM2 16l-.685-.305a.753.753 0 000 .61L2 16zm.836 0l.02.039c.12.23.306.564.56.968A17.168 17.168 0 005.78 19.97c2.15 2.15 5.47 4.28 10.22 4.28 4.75 0 8.07-2.13 10.22-4.28a17.168 17.168 0 002.364-2.963 14.205 14.205 0 00.58-1.007 14.205 14.205 0 00-.58-1.007 17.168 17.168 0 00-2.364-2.963C24.07 9.88 20.75 7.75 16 7.75c-4.75 0-8.07 2.13-10.22 4.28a17.168 17.168 0 00-2.364 2.963A14.205 14.205 0 002.836 16zM30 16l.685.305a.754.754 0 000-.61L30 16zm-.685.305z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11.75a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5zM10.25 16a5.75 5.75 0 1111.5 0 5.75 5.75 0 01-11.5 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PasswordVisibilityOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.583 12.641a.75.75 0 00-1.166.943c.65.806 1.468 1.68 2.462 2.51L3.338 20.5a.75.75 0 101.3.75l2.445-4.241a15.31 15.31 0 004.768 2.21l-.765 4.351a.75.75 0 001.477.26l.755-4.295c.844.139 1.738.215 2.682.215.94 0 1.828-.076 2.667-.213l.757 4.293a.75.75 0 101.477-.26l-.766-4.347a15.31 15.31 0 004.774-2.209l2.442 4.212a.75.75 0 101.298-.752L26.113 16.1a18.01 18.01 0 002.47-2.516.75.75 0 00-1.166-.943 16.339 16.339 0 01-2.652 2.62l-.004.003a.754.754 0 00-.158.122c-2.086 1.58-4.914 2.864-8.603 2.864a14.74 14.74 0 01-3.046-.31.755.755 0 00-.166-.037c-3.934-.878-6.593-3.266-8.205-5.262z"
        fill="currentColor"
      />
    </svg>
  );
}






export const DocsPageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  className="h-6 w-6 shrink-0"
  aria-hidden
  {...props}
>
  <path
    d="M7.25 16.25H13.75V14.75H7.25V16.25ZM7.25 12.25H16.75V10.75H7.25V12.25ZM7.25 8.25H16.75V6.75H7.25V8.25ZM3.5 20V3H20.5V20H3.5ZM5 18.5H19V4.5H5V18.5Z"
    fill="#AC75FF"
    fillOpacity="0.65"
  />
</svg>
);

export const AcademyPageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M2 3L8 1L14 3L8 5L2 3Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M2 7L8 9L14 7M2 11L8 13L14 11"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Ask AI Chat Panel Icons
export const ExpandPanelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66654 16.296L1.95508 11.5845L6.66654 6.87305L7.55758 7.76409L3.72424 11.5974L7.54466 15.4178L6.66654 16.296ZM13.3332 16.296L12.4422 15.4049L16.2755 11.5716L12.4551 7.75117L13.3332 6.87305L18.0447 11.5845L13.3332 16.296Z"
      fill="currentColor"
    />
  </svg>
);

export const NewChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.44141 20.5576L2.9062 15.5512C2.64231 14.9871 2.43905 14.4091 2.29641 13.817C2.15377 13.2251 2.08245 12.6194 2.08245 11.9999C2.08245 10.9048 2.29023 9.87561 2.70578 8.91242C3.12134 7.94922 3.6853 7.11138 4.39766 6.39888C5.11002 5.68638 5.94773 5.12235 6.91078 4.70679C7.87384 4.2911 8.9028 4.08325 9.99766 4.08325C11.0927 4.08325 12.1219 4.29103 13.0854 4.70658C14.0488 5.12214 14.8869 5.6861 15.5995 6.39846C16.3122 7.11082 16.8764 7.94853 17.2922 8.91159C17.7079 9.87464 17.9158 10.9036 17.9158 11.9985C17.9158 13.0935 17.7079 14.1227 17.2922 15.0862C16.8767 16.0496 16.3127 16.8877 15.6002 17.6003C14.8877 18.313 14.0498 18.8772 13.0866 19.293C12.1234 19.7087 11.0943 19.9166 9.99911 19.9166C9.37967 19.9166 8.77398 19.8453 8.18203 19.7026C7.58995 19.56 7.01189 19.3567 6.44787 19.0928L1.44141 20.5576ZM3.29078 18.7083L5.95745 17.9166C6.16259 17.861 6.3605 17.8376 6.5512 17.8462C6.74189 17.8546 6.93286 17.9059 7.12411 17.9999C7.56856 18.2221 8.03384 18.3888 8.51995 18.4999C9.00606 18.611 9.49911 18.6666 9.99911 18.6666C11.8602 18.6666 13.4366 18.0208 14.7283 16.7291C16.0199 15.4374 16.6658 13.861 16.6658 11.9999C16.6658 10.1388 16.0199 8.56242 14.7283 7.27075C13.4366 5.97909 11.8602 5.33325 9.99911 5.33325C8.138 5.33325 6.56161 5.97909 5.26995 7.27075C3.97828 8.56242 3.33245 10.1388 3.33245 11.9999C3.33245 12.4999 3.388 12.993 3.49911 13.4791C3.61023 13.9652 3.77689 14.4305 3.99911 14.8749C4.09634 15.0555 4.14974 15.2464 4.15932 15.4478C4.16891 15.6492 4.14328 15.8471 4.08245 16.0416L3.29078 18.7083ZM9.37411 15.1249H10.6241V12.6249H13.1241V11.3749H10.6241V8.87492H9.37411V11.3749H6.87411V12.6249H9.37411V15.1249Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpwardsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.4288 8.63883L13.525 9.51716L10.3423 6.33445V16.4274H9.09232V6.33445L5.90961 9.51716L5.00586 8.63883L9.71732 3.92737L14.4288 8.63883Z"
      fill="currentColor"
    />
  </svg>
);

export const AskAiChatHeaderBrandIcon = (props: SVGProps<SVGSVGElement>) => {
  const gradId = `ask-ai-chat-header-grad-${useId().replace(/:/g, '')}`;
  return (
    <svg
      className="size-4 shrink-0"
      width={16}
      height={16}
      viewBox="0 0 18 18"
      aria-hidden
      {...props}
    >
      <defs>
        <linearGradient
          id={gradId}
          x1="9"
          y1="3.5"
          x2="9"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#b0f7ba" />
          <stop offset="0.5" stopColor="rgba(137, 156, 250, 0.6)" />
          <stop offset="1" stopColor="rgba(172, 117, 255, 0)" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradId})`}
        d="M8.99982 8.99963L12.75 10.875L8.99982 12.7498L7.125 16.5L5.24963 12.7498L1.5 10.875L5.24963 8.99963L7.125 5.25L8.99982 8.99963Z"
      />
      <path
        fill="#9fe8d0"
        d="M14.2499 3.78787L16.5 4.91309L14.2499 6.03798L13.125 8.28809L11.9998 6.03798L9.75 4.91309L11.9998 3.78787L13.125 1.53809L14.2499 3.78787Z"
      />
    </svg>
  );
};

export const AskAiSparkleIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = `ask-ai-sparkle-mask-${useId().replace(/:/g, '')}`;
  const gradId1 = `ask-ai-sparkle-grad1-${useId().replace(/:/g, '')}`;
  const gradId2 = `ask-ai-sparkle-grad2-${useId().replace(/:/g, '')}`;
  
  return (
    <svg 
      width="15" 
      height="15" 
      viewBox="0 0 15 15" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <defs>
        <mask 
          id={maskId} 
          style={{maskType: 'alpha'}} 
          maskUnits="userSpaceOnUse" 
          x="0" 
          y="0" 
          width="15" 
          height="15"
        >
          <rect width="15" height="15" fill="#D9D9D9" />
        </mask>
        <linearGradient 
          id={gradId1} 
          x1="0.296875" 
          y1="0.796875" 
          x2="15.7554" 
          y2="13.9682" 
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#B0F7BA" />
          <stop offset="0.5" stopColor="#899CFA" />
          <stop offset="0.9" stopColor="#AC75FF" />
        </linearGradient>
        <linearGradient 
          id={gradId2} 
          x1="0.296875" 
          y1="0.796875" 
          x2="15.7554" 
          y2="13.9682" 
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#B0F7BA" />
          <stop offset="0.5" stopColor="#899CFA" />
          <stop offset="0.9" stopColor="#AC75FF" />
        </linearGradient>
      </defs>
      <g mask={`url(#${maskId})`}>
        <path 
          d="M9.90081 5.59849L14.7031 8L9.90081 10.4008L7.5 15.2031L5.09849 10.4008L0.296875 8L5.09849 5.59849L7.5 0.796875L9.90081 5.59849Z" 
          fill={`url(#${gradId1})`} 
        />
        <path 
          d="M13.3515 2.1483L14.7031 2.82421L13.3515 3.49992L12.6758 4.85154L11.9999 3.49992L10.6485 2.82421L11.9999 2.1483L12.6758 0.796875L13.3515 2.1483Z" 
          fill={`url(#${gradId2})`} 
        />
      </g>
    </svg>
  );
};

export const AskAiHeaderNewChatBubbleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="size-5 shrink-0"
    aria-hidden
    {...props}
  >
    <path
      d="M1.44208 18.5578L2.90687 13.5513C2.64298 12.9873 2.43972 12.4092 2.29708 11.8171C2.15444 11.2252 2.08312 10.6195 2.08312 10C2.08312 8.9049 2.2909 7.87574 2.70645 6.91254C3.12201 5.94935 3.68597 5.1115 4.39833 4.399C5.11069 3.6865 5.9484 3.12247 6.91145 2.70692C7.87451 2.29122 8.90347 2.08337 9.99833 2.08337C11.0933 2.08337 12.1226 2.29115 13.086 2.70671C14.0495 3.12226 14.8876 3.68622 15.6002 4.39858C16.3128 5.11094 16.8771 5.94865 17.2929 6.91171C17.7086 7.87476 17.9165 8.90372 17.9165 9.99858C17.9165 11.0936 17.7086 12.1228 17.2929 13.0863C16.8774 14.0498 16.3133 14.8878 15.6008 15.6005C14.8883 16.3131 14.0505 16.8773 13.0873 17.2932C12.1241 17.7089 11.0949 17.9167 9.99979 17.9167C9.38034 17.9167 8.77465 17.8454 8.1827 17.7027C7.59062 17.5601 7.01256 17.3568 6.44854 17.093L1.44208 18.5578ZM3.29145 16.7084L5.95812 15.9167C6.16326 15.8612 6.36117 15.8377 6.55187 15.8463C6.74256 15.8548 6.93354 15.906 7.12479 16C7.56923 16.2223 8.03451 16.3889 8.52062 16.5C9.00673 16.6112 9.49979 16.6667 9.99979 16.6667C11.861 16.6667 13.4374 16.0208 14.7291 14.7292C16.0207 13.4375 16.6666 11.8611 16.6666 10C16.6666 8.13889 16.0207 6.5625 14.7291 5.27083C13.4374 3.97917 11.861 3.33333 9.99979 3.33333C8.13868 3.33333 6.56229 3.97917 5.27062 5.27083C3.97896 6.5625 3.33312 8.13889 3.33312 10C3.33312 10.5 3.38868 10.9931 3.49979 11.4792C3.6109 11.9653 3.77756 12.4306 3.99979 12.875C4.09701 13.0556 4.15041 13.2465 4.15999 13.4479C4.16958 13.6493 4.14395 13.8472 4.08312 14.0417L3.29145 16.7084ZM9.37479 13.125H10.6248V10.625H13.1248V9.375H10.6248V6.875H9.37479V9.375H6.87479V10.625H9.37479V13.125Z"
      fill="white"
      fillOpacity={0.46}
    />
  </svg>
);

export const ThumbsUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 17.5V8.33333H5.83333V17.5H2.5ZM7.5 17.5V8.33333L10.8333 2.5L11.6667 2.91667C11.9167 3.04167 12.1111 3.22917 12.25 3.47917C12.3889 3.72917 12.4444 3.99306 12.4167 4.27083L11.875 8.33333H16.6667C16.9722 8.33333 17.2361 8.45139 17.4583 8.6875C17.6806 8.92361 17.7778 9.19444 17.75 9.5L16.6667 15.1667C16.5833 15.5 16.4028 15.7639 16.125 15.9583C15.8472 16.1528 15.5417 16.25 15.2083 16.25H7.5V17.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ThumbsDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 2.5V11.6667H14.1667V2.5H17.5ZM12.5 2.5V11.6667L9.16667 17.5L8.33333 17.0833C8.08333 16.9583 7.88889 16.7708 7.75 16.5208C7.61111 16.2708 7.55556 16.0069 7.58333 15.7292L8.125 11.6667H3.33333C3.02778 11.6667 2.76389 11.5486 2.54167 11.3125C2.31944 11.0764 2.22222 10.8056 2.25 10.5L3.33333 4.83333C3.41667 4.5 3.59722 4.23611 3.875 4.04167C4.15278 3.84722 4.45833 3.75 4.79167 3.75H12.5V2.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 15C7.04167 15 6.64931 14.8368 6.32292 14.5104C5.99653 14.184 5.83333 13.7917 5.83333 13.3333V3.33333C5.83333 2.875 5.99653 2.48264 6.32292 2.15625C6.64931 1.82986 7.04167 1.66667 7.5 1.66667H14.1667C14.625 1.66667 15.0174 1.82986 15.3438 2.15625C15.6701 2.48264 15.8333 2.875 15.8333 3.33333V13.3333C15.8333 13.7917 15.6701 14.184 15.3438 14.5104C15.0174 14.8368 14.625 15 14.1667 15H7.5ZM7.5 13.3333H14.1667V3.33333H7.5V13.3333ZM4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8438C2.66319 17.5174 2.5 17.125 2.5 16.6667V5H4.16667V16.6667H13.3333V18.3333H4.16667Z"
      fill="currentColor"
    />
  </svg>
);
